{
  "ca-ES": "Catalan - Català",
  "de-DE": "German - Deutch",
  "en-GB": "English",
  "en-US": "American",
  "es-ES": "Spanish - Español",
  "es-US": "Spanish (US)",
  "fr-FR": "French - Français",
  "hi-IN": "Hindi",
  "id-ID": "Indonesian",
  "insufficientFilePermissions": "The user does not have sufficient permissions for file",
  "it-IT": "Italian - Italiano",
  "ja-JP": "Japanese",
  "ko-KR": "Korean",
  "nl-NL": "Dutch",
  "pl-PL": "Polish",
  "pt-BR": "Portuguese (BR)",
  "ru-RU": "Russian",
  "storageQuotaExceeded": "The user's Drive storage quota has been exceeded.",
  "uk-UA": "Ukrainian - Yкраїнська",
  "zh-CN": "Chinese",
  "zh-HK": "Chinese (HK)",
  "zh-TW": "Chinese (TW)",
  "ABOUT_BUILD": "Build",
  "ABOUT_EXPIRY": "Subscription expires on",
  "ABOUT_PLAN": "Subscription plan:",
  "ABOUT_TITLE": "About",
  "ABOUT_VERSION": "Version",
  "ACCESS-ADMIN-EMAIL": "Administrator email",
  "ACCESS-ADMIN-NAME": "Administrator name",
  "ACCESS-ADMIN-NOTES": "Administartor notes",
  "ACCESS-DOMAIN": "Domain name",
  "ACCESS-NAME": "Access name",
  "ACCESS-USERS-EMAIL": "Mail of user#",
  "ACCESS-USERS-NAME": "Name of user#",
  "ACCESS-USERS-NOTES": "Notes of user#",
  "ACCESSCONFIG_ADMIN": "Administrator",
  "ACCESSCONFIG_BUY": "Purchase",
  "ACCESSCONFIG_BUY_SUBSCRIPTION": "Buy as private",
  "ACCESSCONFIG_CANCEL": "Cancel",
  "ACCESSCONFIG_CREATEDBY": "Created by",
  "ACCESSCONFIG_CREATIONDATE": "Creation date",
  "ACCESSCONFIG_DELETE_SUBSCRIPTION": "Delete subscription",
  "ACCESSCONFIG_DETAILS": "Configure access",
  "ACCESSCONFIG_DISCOVER": "Discover school offers",
  "ACCESSCONFIG_DOMAIN": "Domain",
  "ACCESSCONFIG_DOMAINLICS": "Domain max users",
  "ACCESSCONFIG_DOMAINLICS_DESC": "It's the maximum users number for the specified domain. Use 0 to allow unlimited users.",
  "ACCESSCONFIG_DOMAIN_DESC": "All the users with a Google account (not @gmail.com) and specified domani can access to SMX studio.",
  "ACCESSCONFIG_DOMAIN_PLACEHOLDER": "Domain to enable",
  "ACCESSCONFIG_EXPIREDATE": "Expire date: ",
  "ACCESSCONFIG_EXPIRE_DATE_DESC": "It's the subscription expiry date",
  "ACCESSCONFIG_HISTORY": "Order history",
  "ACCESSCONFIG_INSERT_DOMAIN": "Add domain",
  "ACCESSCONFIG_INSERT_GROUP": "Add users group",
  "ACCESSCONFIG_INSERT_SINGLE": "Add single user",
  "ACCESSCONFIG_LASTMODIFICATIONBY": "Updated by",
  "ACCESSCONFIG_LASTMODIFICATIONDATE": "Last update",
  "ACCESSCONFIG_LICENSETYPE": "License type: ",
  "ACCESSCONFIG_LICENSE_DOMAIN": "Domain",
  "ACCESSCONFIG_LICENSE_LICENSE": "licenses",
  "ACCESSCONFIG_LICENSE_MULTI": "Multiple",
  "ACCESSCONFIG_LICENSE_SINGLE": "Single",
  "ACCESSCONFIG_LIMITED_LICENSES": "(up to %s users)",
  "ACCESSCONFIG_LOCKED": "Contract status",
  "ACCESSCONFIG_LOCKED_ACCEPTED": "Acceptance date",
  "ACCESSCONFIG_LOCKED_FALSE": "Accepted",
  "ACCESSCONFIG_LOCKED_TRUE": "Waiting for acceptance",
  "ACCESSCONFIG_MECHCODE": "Mechanographic code",
  "ACCESSCONFIG_MODIFY-ORDER": "Edit/Renew manually",
  "ACCESSCONFIG_MSG": "Manage user email addresses of SMX studio",
  "ACCESSCONFIG_MSG_DELETE_FAIL": "ERROR during subscription deletion",
  "ACCESSCONFIG_MSG_DELETE_OK": "Subscription has been deleted.",
  "ACCESSCONFIG_MSG_SAVE_FAIL": "Access list saving failed.",
  "ACCESSCONFIG_MSG_SAVE_FAIL_ACCEPT": "Error saving contract acceptance.",
  "ACCESSCONFIG_MSG_SAVE_SUCCESS": "Access list saving success.",
  "ACCESSCONFIG_MSG_SINGLE": "Manage user email address of SMX studio",
  "ACCESSCONFIG_NAME": "Config name",
  "ACCESSCONFIG_NAME_DESC": "Write a name to identify this configuration. This name will be useful to identify the configuration in case of multiple subscriptions.",
  "ACCESSCONFIG_NAME_PLACEHOLDER": "i.e. Section 2A or John's afterschool",
  "ACCESSCONFIG_OCR_POLICY": "OCR Counting",
  "ACCESSCONFIG_OCR_QUOTA": "OCR Quota",
  "ACCESSCONFIG_OPENSTATS": "Open statistics",
  "ACCESSCONFIG_OPERATORS": "Operators",
  "ACCESSCONFIG_ORDERID": "Key ID: ",
  "ACCESSCONFIG_ORDER_ACTIVE": "ACTIVE",
  "ACCESSCONFIG_ORDER_EXPIRED": "EXPIRED",
  "ACCESSCONFIG_ORDER_STATUS": "Order status: ",
  "ACCESSCONFIG_ORDER_SUSPENDED": "SUSPENDED",
  "ACCESSCONFIG_ORIGIN": "Origin: ",
  "ACCESSCONFIG_PLAN": "Plan",
  "ACCESSCONFIG_PRICE": "Price",
  "ACCESSCONFIG_PRICE_NA": "Not available",
  "ACCESSCONFIG_REFORDERID": "External reference ID: ",
  "ACCESSCONFIG_RENEW_INVALID_ORDER": "The order to be renewed is invalid. Please contact customer service.",
  "ACCESSCONFIG_RENEW_SUBSCRIPTION": "Renew subscription",
  "ACCESSCONFIG_RESET": "Cancel changes",
  "ACCESSCONFIG_SAVE": "Save",
  "ACCESSCONFIG_SENDADMINEMAIL": "Send email to administrator",
  "ACCESSCONFIG_SENDEMAIL": "Send email to buyer",
  "ACCESSCONFIG_SLOTS": "Additional emails",
  "ACCESSCONFIG_TITLE": " Access config",
  "ACCESSCONFIG_UNLIMITED_LICENSES": "(unlimited users)",
  "ACCESSCONFIG_UNLOCK": "I accept the contract",
  "ACCESSCONFIG_UPDATE_ORDER": "Update order",
  "ACCESSCONFIG_USERADMIN": "Administrator",
  "ACCESSCONFIG_USERADMIN_DESC": "Email account that can manage the supbscription's access permissions.",
  "ACCESSCONFIG_USERADMIN_DESC_SINGLE": "Email account that can manage the supbscription's access permissions.",
  "ACCESSCONFIG_USERADMIN_PLACEHOLDER": "Administrator email",
  "ACCESSCONFIG_USERADMIN_SINGLE": "Email",
  "ACCESSCONFIG_USERS": "Users",
  "ACCESSCONFIG_USERS_DESC": "Email adresses than can access SuperMapX.",
  "ACCESSCONFIG_USERS_DESC_NODOMAIN": "Email adresses than can access SuperMapsX not included in specified domain",
  "ACCESSCONFIG_USERS_NAME_PLACEHOLDER": "Name",
  "ACCESSCONFIG_USERS_NOTE_PLACEHOLDER": "Notes",
  "ACCESSCONFIG_USERS_PLACEHOLDER": "Email",
  "ACCESSCONFIG_USERS_WARNING": "WARNING: must be email Google accounts",
  "ACCESSCONFIG_USER_NAME": "Buyer",
  "ACCESSCONFIG_USER_NAME_PLACEHOLDER": "Buyer's name",
  "ACCESS_CONFIG": "Access management",
  "ACTIVE_ITEM_CREATION_LIMIT_EXCEEDED": "This account has exceeded the creation limit of 500 million items. To create more items, permanently delete some items.",
  "ACTUAL_SIZE": "Actual Size",
  "ADD": "Add",
  "ADD_CUSTOM_LINK": "Add link",
  "ADMIN_NAME": "Configuration name",
  "ADMIN_TITLE": "Access management",
  "ADVANCED_KEYBOARD_LABEL": "Advanced basic keyboard",
  "AI_PROMPT": "AI prompt for math",
  "AI_PROMPT_BUTTON": " Copy math prompt",
  "AI_PROMPT_COPIED": "Math prompt copied in clipboard",
  "AI_PROMPT_DESC": "Do you want to write math with an AI compatible with SMX studio?Abilita questa opzione e copia il prompt dagli strumenti aggiuntivi e incollalo nella chat con la tua AI preferita. Enable this option and copy the prompt from the additional tools and paste it in the chat with your favorite AI.",
  "AI_PROMPT_MATH": "I would like you to write all mathematical formulas in the following way from now on: - At the beginning of the formula, use this delimiter: @@@STARTLATEX@@@ - At the end of the formula, use this delimiter: @@@ENDLATEX@@@ - All mathematical expressions within the delimiters must be written in valid LaTeX.",
  "CLAIRE": "Claire",
  "ALIGNMENT_TOOLBAR-ALIGN": "Align",
  "ALIGNMENT_TOOLBAR-BOTTOM": "Bottom",
  "ALIGNMENT_TOOLBAR-CENTER": "Center",
  "ALIGNMENT_TOOLBAR-LEFT": "Left",
  "ALIGNMENT_TOOLBAR-RIGHT": "Right",
  "ALIGNMENT_TOOLBAR-TOP": "Top",
  "ALLSAVED": "All changes are saved",
  "ALL_MAPS": "All",
  "ALREADY_OPEN": "Document already opened",
  "ANALYSIS_LABEL": "Analysis",
  "APP_NAME": "SMX studio",
  "ARRANGE_BASE": "The entire map will be reorganized as a top-bottom tree.",
  "ARRANGE_CONFIRM": "Confirm?",
  "ARRANGE_WARNING_CURVES": " • Curved edges that will be straightened",
  "ARRANGE_WARNING_END": "Using this command could generate a map that will need manual adjustment.",
  "ARRANGE_WARNING_LOCKED": " • Locked nodes that won't be moved",
  "ARRANGE_WARNING_PAIRS": " • Pair-to-pair relations that could generate a bad map layout",
  "ARRANGE_WARNING_START": "WARNING: This map contains some of these features:",
  "ASK_CLEAR_CHAT": "Delete the chat? Messages can no longer be recovered.",
  "ATTACHMENT": "Attachment",
  "ATTACH_TO_NODE": "Attach to node",
  "AUTH_ERROR": "Invalid Credentials",
  "AUTODRAW": "Autodraw",
  "AUTODRAW_DESC_1": "Autodraw is provided by ",
  "AUTOMATIC_ZOOM": "Automatic zoom",
  "AVATAR": "Avatar",
  "BACK_TO_LOGIN": "Back to login",
  "BASIC_KEYBOARD_LABEL": "Basic keyboard",
  "BORDER_COLOR": "Border",
  "BROWSE": "Browse",
  "BRUSH": "Draw",
  "BUTTON_CLOSE": "Close",
  "BUTTON_EXPAND": "Expand",
  "BUTTON_NO": "No",
  "BUTTON_OK": "Ok",
  "BUTTON_REDUCE": "Reduce",
  "BUTTON_YES": "Yes",
  "CANCEL": "Cancel",
  "CAPTURE": "Capture image",
  "CAPTURE_CAMERA": "Capture",
  "CAPTURE_INFO": "Drag the mouse over the notepad to cut out an image",
  "CAPTURE_LOADER_WAIT": "Loading...",
  "CAPTURE_MATH": "Capture mathematical formula",
  "CHANGE_COLOR": "Change color",
  "CHANGE_NAME": "Change name",
  "CHAT_CLEAR": "Delete chat",
  "CHAT_MESSAGES_UNREAD": "UNREAD MESSAGES",
  "CHAT_SEND": "Send message",
  "CHAT_TODAY": "Today",
  "CHAT_YESTERDAY": "Yesterday",
  "CHECK": "Check",
  "CHOOSE_AVATAR": "Change photo",
  "CIRCLE": "Circle",
  "CLOSE": "Close",
  "CLOSE_MATH": "Close math keyboard",
  "COLOR": "Color",
  "CONFIGPDF": "Annotation Configuration",
  "CONFIG_SUBSCRIPTIONS": "Manage subscriptions",
  "CONFIRM_DELETE_PDF": "Do you confirm the deletion of the document?",
  "CONFIRM_PASSWORD": "Confirm password",
  "CONFIRM_RELOAD_PDF": "he PDF was edited in another session<br>and will be updated to the latest version.",
  "CONFIRM_RESTORE_PDF": "The pdf has been deleted. Do you want to recover it?",
  "CONFIRM_USERS_DELETE": "This operation will remove the user from Firebase and also all related data. Are you sure you want to delete this user?",
  "CONTINUE_WITH_GOOGLE": "Continue with Google",
  "COPY": "Copy",
  "COPYOF": "Copy of ",
  "COPY_HIGHLIGHT": "Copy highlighted text",
  "COPY_LATEX": "Copy LaTeX",
  "COPY_LINK": "COPY",
  "COPY_MAP": "Create a copy",
  "COPY_MAP_FOR_EDIT": "Create a copy to edit",
  "COPY_ON_DEEP_MSG": "Text in deep",
  "COPY_ON_NOTEPAD_MSG": "Text pasted in notepad",
  "COPY_PASTE_INFO1": "Copying and pasting in SMX studio",
  "COPY_PASTE_INFO2": "These actions are unavailable via the Edit menu, but you can still use:",
  "COPY_PASTE_INFO3_C": "for copy",
  "COPY_PASTE_INFO3_V": "for paste",
  "COPY_PASTE_INFO3_X": "for cut",
  "COPY_SHOW": "SHOW",
  "COPY_UNDERLINE": "Copy underlined text",
  "CREATE_GOOGLE_DOC": "Create Google Doc",
  "CREATE_MAP_ERROR": "Error creating new map",
  "CREATE_NEW_MAP": "Create new map",
  "CREATE_PROFILE": "Your SMX studio profile",
  "CREATE_PROFILE_BUTTON": "Create profile",
  "CREATE_RECENT_COPY": "Create a copy",
  "CREATE_TAG": "Create",
  "CREATING_COPY": "Creating copy",
  "CROP_IMAGE_COPY": "Copy",
  "CROP_IMAGE_COPY_MSG": "Image copied to clipboard",
  "CROP_PASTE_SELECTION": "Crop and paste",
  "CROP_SELECTION": "Crop image",
  "CURRENT_PAGE": "Page",
  "CUSTOM": "Custom",
  "DAILY_LIMIT_EXCEEDED": "Daily Limit Exceeded",
  "DATE_NOTIFICATION": "Date: ",
  "DEEPTEXT": "In-depth text",
  "DEEP_CLOSE_MODIFY": "Close editor",
  "DEEP_HIDE_IMAGE": "Hide image",
  "DEEP_OPEN_MODIFY": "Edit deep text",
  "DEEP_SHOW_IMAGE": "Show image",
  "DELETE": "Delete",
  "DELETE_ALL_DATA": "Delete all data",
  "DELETE_CONFIRM": "Do you really want to delete order '§orderid§'?",
  "DELETE_DEEPTEXT": "In-depth text",
  "DELETE_EDGE": "Edge",
  "DELETE_FILE": "Delete file",
  "DELETE_IMAGE": "Image",
  "DELETE_LINK": "Link",
  "DELETE_NODE": "Node",
  "DELETE_RECENT_MAP": "Delete permamently",
  "DELETE_TAG": "Delete tag '%s'?",
  "DELETE_TAG_CONFIRM": "Removing the tag will remove it from all files that have been assigned it.",
  "DELETE_TAG_TITLE": "Delete tag",
  "DELETE_TEXT": "Text",
  "DELETE_VIDEO": "Video",
  "DEMO_REQUEST_1": "You are requesting a demonstration period of 30 days, during which you will have access to all the features of SMX studio.",
  "DEMO_REQUEST_2": "At the end of the demonstration period in the [Manage subscription] area you can purchase a subscription and continue using it, finding all your created maps.",
  "DEMO_REQUEST_3A": "To activate the demo period, press the",
  "DEMO_REQUEST_3B": "button and log in with the user you wish to activate.",
  "DEMO_REQUEST_4": "Please note: the account must be a valid Google email.",
  "DEMO_REQUEST_BUTTON": "Try it for 30 days",
  "DESC_APP": "Conceptual maps for learning",
  "DESC_DELETE_DATA": "Save the User code! If you want to recover the maps go to the dedicated page (admin-move-map) and when the user is logged in, check the new UID and copy the data from the old one to the new.",
  "DESMOS_CALCULATOR": "Graphing Calculator",
  "DESMOS_DESC_1": "Desmos tools are provided by",
  "DESMOS_DESC_2": "Anastasis does not provide assistance or guarantees on these services.",
  "DESMOS_DESC_3": "In order to use these tools from the extra Menu",
  "DESMOS_DESC_4": " you have to enable them from the menu below and save.",
  "DESMOS_FOURFUNCTIOM": "Function Calculator",
  "DESMOS_GEOMETRY": "Geometry",
  "DESMOS_MATH_TOOLS": "Desmos tools",
  "DESMOS_SCIENTIFIC": "Scientific Calculator",
  "DIRTY": "There are unsaved changes",
  "DISCONNECT": "Disconnect",
  "DISEQ_LABEL": "Disequations",
  "DOC_AUTHOR": "Author",
  "DOC_COPIED": "Document copied",
  "DOC_CREDITS": "Created with SMX studio - Anastasis",
  "DOC_IMPORTED": "Document imported",
  "DOC_MAP_IMAGES": "Map images",
  "DOC_MULTI_IMPORTED": "%count% documents imported",
  "DOC_NOTES": "Notes",
  "DOC_PICKER_TITLE": "Select document",
  "DOMAIN_FULL": "The workspace has reached the maximum number of users. To login you need to ask the administrator to delete unused users.",
  "DOWNLOAD": "Download",
  "DOWNLOAD_CHROME": "To use SMX studio you must download",
  "DOWNLOAD_CHROME2": "free Google Chrome browser is requested",
  "DOWNLOAD_RECENT": "Download",
  "DRAW_TITLE": "Draw",
  "DRAW_TOOLS": "Drawing tools",
  "DRIVE_HIERARCHY_DEPTH_LIMIT_EXCEEDED": "Your My Drive can't contain more than 100 levels of folders.",
  "DRIVE_QUOTA_EXCEEDED": "There is not enough space on Google Drive. Try freeing up some space and try again.",
  "DRIVE_QUOTA_EXCEEDED_MESSAGE_MAPVIEW": "The user's Drive storage quota has been exceeded. To edit the map you need to free up storage space. Do you want to open the map in view only mode?",
  "DRIVE_USAGE": "Storage space used",
  "DROP_HERE": "Drag the file to upload here",
  "DROP_HERE_IMAGE": "Drag the image to upload here",
  "DROP_MULTIPLE_FILES": "Only one document will be imported.",
  "DROP_PDF": "drag and drop the pdf here",
  "EDGE_CURVE": "Curve",
  "EDGE_STRAIGHT": "Stright",
  "EDIT": "Edit",
  "EDIT_DOC": "Edit document",
  "EDIT_IMAGE": "Edit image",
  "EDIT_MODE": "Edit",
  "EDIT_NODE_TITLE": "Node title",
  "EDIT_NOTIFICATION": "Edit",
  "EDIT_PASSWORD": "Edit password",
  "EDIT_PROFILE": "Your profile",
  "EDIT_TEXT": "Edit text",
  "EMAIL_ALREADY_EXISTS_MSG": " has been already added in the access list.",
  "EMPTY_NAME_DOC_NOT_ALLOWED": "Document name cannot be empty",
  "EMPTY_NAME_NOT_ALLOWED": "Configuration name cannot be empty",
  "ENTER_LATEX_MODE": "Enter LaTex mode",
  "ERROR-SAVING": "Warning! error on saving",
  "ERROR_AUTHENTICATION": "Authentication error",
  "ERROR_CONVERTDATAURL": "Error convert data URL",
  "ERROR_DATABASE": "Generic database error",
  "ERROR_DOC_NOT_FOUND": "Document not found",
  "ERROR_DOC_SHARED_WITH_ACCESS": "To open this document you must log in with the account with which it was shared",
  "ERROR_GENERATESME": "Generic generate sme error",
  "ERROR_GETPROTOCOL": "Error get http protocol",
  "ERROR_GOOGLEDRIVE": "Generic Google Drive error",
  "ERROR_GOOGLEID_NOT_FOUND": "Document does not exist or is not shared anymore",
  "ERROR_GRAPHML2JSON": "Generic error on converting graphml to json",
  "ERROR_IMPORT_DOC": "Error on importing doc",
  "ERROR_INSERT_IMAGE": "Invalid image",
  "ERROR_INVALID_CREDENTIALS": "Google Drive access denied. Logout and login again to solve the problem.",
  "ERROR_LINK_PREVIEW": "Error link preview",
  "ERROR_MAPJSONEMPTY": "Error Map JSON is empty",
  "ERROR_MAP_FORMAT_NOT_SUPPORTED": "Unsupported file type",
  "ERROR_MAP_NOT_SHARED": "This map is not shared",
  "ERROR_NO_IMAGE_IN_CLIPBOARD": "No image in clipboart to paste",
  "ERROR_OPENMAP": "Map not found",
  "ERROR_OPEN_MAP": "Error opening the map",
  "ERROR_OWNER_NOT_FOUND": "This map does not exist or is not shared anymore",
  "ERROR_READFILE": "Generic error read file",
  "ERROR_RESIZEPNG": "Error resize to png",
  "ERROR_SENDMAIL": "Error sending mail to user",
  "ERROR_STORAGE_DOWNLOAD": "Download from storage error",
  "ERROR_UNSUPPORTEDPROTOCOL": "Unsupported uri protocol",
  "ERROR_UNZIPMAP": "Error unzipping map",
  "ERROR_WRITEFILE": "Generic error write file",
  "ERROR_WRITEJSON": "Error writing JSON",
  "ERROR_WRONGFILETYPE": "Error wrong file type",
  "ERROR_WRONG_FILETYPE": "The file is not a valid .sme map",
  "ERROR_ZIPPER": "Error creating zip",
  "ERR_ACCESS_DENIED": "All scopes must be accepted in order to continue in SMX studio",
  "ERR_DIFFERENT_PASSWORD": "Attention! The two passwords do not match.",
  "ERR_EARLY_START": "Your account will be active from",
  "ERR_GDRIVE_3PTY_DISABLED": "Your domain administratore has disabled 3rd party apps.",
  "ERR_LENGTH_PASSWORD": "Attention! The password must be at least 12 characters.",
  "ERR_LOCKED": "This user is temporarily blocked.<br />You will be able to access after your administrator accepts the contract terms.",
  "ERR_LOGIN_BACK_TO_LOGIN": "Retry to login",
  "ERR_LOGIN_DOUBLE_ACCESS": "You have already logged from another device.",
  "ERR_LOGIN_DOUBLE_ACCESS_2": "Pressing \"Continue\", the previous session will be disconnected and you can work form here.",
  "ERR_LOGIN_GOOGLE": "Error in Google login",
  "ERR_LOGIN_INVALID_CREDENTIALS": "Your credentials are invalid",
  "ERR_LOGIN_MIXED": "You must select the same use in both login pages",
  "ERR_LOGIN_NOT_VALID_SCOPES": "All scopes must be accepted in order to continue in SMX studio",
  "ERR_LOGIN_SESSION_EXPIRED": "Your session has expired.",
  "ERR_OLD_PASSWORD": "The old password is incorrect.",
  "ERR_ONE_LETTER": "Attention! Must contain at least one letter.",
  "ERR_ONE_SYMBOL": "Attention! Must contain at least one special character and a number.",
  "ERR_SAME_PASSWORD": "Attention! the new password is the same as the current one",
  "ERR_SAVE_PASSWORD": "An error occurred while saving.",
  "ERR_TOKEN_EXPIRED": "Autorizza SMX studio ad usare Google",
  "EXISTING_ACCOUNT": "Existing account",
  "EXIT": "Exit",
  "EXIT_LATEX_MODE": "Exit LaTex mode",
  "EXIT_MESSAGE": "You have unsaved changes. Are you sure you want to leave this page?",
  "EXPIRED_WARNING_1": "Your subscription expired on ",
  "EXPIRED_WARNING_2": " You can keep viewing your documents without editing them.",
  "EXPIRE_DATE": "Expiry date",
  "EXPORT_IN_GOOGLE_DRIVE": "Export in Google Drive",
  "EXPORT_SUCCESS": "Export successful!",
  "EXP_WARNING_ACCOUNT_EXPIRED": "Your subscription has expired",
  "EXP_WARNING_ACCOUNT_EXPIRED_DATE": "Your subscription expired on",
  "EXP_WARNING_ACCOUNT_EXPIRING_DATE": "Your subscription will expire on",
  "EXP_WARNING_BUY": "Buy subscription",
  "EXP_WARNING_DEMO_EXPIRED": "Your demonstration has expired",
  "EXP_WARNING_DEMO_EXPIRED_DATE": "Your demonstration expired on",
  "EXP_WARNING_DEMO_EXPIRING_DATE": "Your demonstration will expire on",
  "EXP_WARNING_READONLY": "You can only see your maps in read-only mode.",
  "EXP_WARNING_RENEW_REFERRER": "To renew your subscription contact your referrer.",
  "EXP_WARNING_RENEW": "Renew subscription",
  "EXP_WARNING_EXPIRED": "Subscription expired",
  "EXTRACT_PDF": "Extracte page",
  "FAVORITE_TAG": "Favorite",
  "FIELD_REQUIRED": "Field required",
  "FILE_OWNER_NOT_MEMEBER_OF_TEAM_DRIVE": "Cannot move a file into a shared drive as a writer when the owner of the file is not a member of that shared drive.",
  "FILTERS": "Filters",
  "FIND_MORE": "Find more",
  "FIRST_PAGE_LABEL": "First page",
  "FLIP_HOR": "Flip horizontal",
  "FLIP_VERT": "Flip vertical",
  "FORBIDDEN": "You can't access to this resource",
  "FORGOT_PASSWORD": "Forgot password?",
  "FORGOT_PASSWORD_MSG_1": "We'll send instructions to the mail below.",
  "FORGOT_PASSWORD_MSG_2": "Check you mailbox after confirmation.",
  "FORMAT_COPY_FORMAT": "Copy format",
  "FORMAT_NODE_TOOLBAR-ARROW-LEFT": "Left arrow",
  "FORMAT_NODE_TOOLBAR-ARROW-RIGHT": "Right arrow",
  "FORMAT_NODE_TOOLBAR-BACKGROUND-COLOR": "Background color",
  "FORMAT_NODE_TOOLBAR-BOLD": "Bold",
  "FORMAT_NODE_TOOLBAR-BORDER-COLOR": "Border Color",
  "FORMAT_NODE_TOOLBAR-BORDER-SIZE": "Border size",
  "FORMAT_NODE_TOOLBAR-BREAK-LINK": "Break edge",
  "FORMAT_NODE_TOOLBAR-BRING-TO-FRONT": "Bring to front",
  "FORMAT_NODE_TOOLBAR-CURVE-EDGE": "Edge type",
  "FORMAT_NODE_TOOLBAR-ELLIPSE": "Ellipse",
  "FORMAT_NODE_TOOLBAR-FONT": "Font",
  "FORMAT_NODE_TOOLBAR-FONT-SIZE": "Font size",
  "FORMAT_NODE_TOOLBAR-FRAME-IMAGE": "Frame",
  "FORMAT_NODE_TOOLBAR-HIGHLIGHT": "Highlight",
  "FORMAT_NODE_TOOLBAR-INSIDE": "Inside",
  "FORMAT_NODE_TOOLBAR-MYCOLOR": "My Colors",
  "FORMAT_NODE_TOOLBAR-NODE-SHAPE": "Node frame",
  "FORMAT_NODE_TOOLBAR-NONE": "None",
  "FORMAT_NODE_TOOLBAR-OVER": "Over",
  "FORMAT_NODE_TOOLBAR-RECTANGLE": "Rectangle",
  "FORMAT_NODE_TOOLBAR-REMOVE-IMAGE": "Remove image",
  "FORMAT_NODE_TOOLBAR-ROUNDRECT": "Rounded",
  "FORMAT_NODE_TOOLBAR-SEND-TO-BACK": "Send to back",
  "FORMAT_NODE_TOOLBAR-STRAIGHTEN-EDGE": "Straighten edge",
  "FORMAT_NODE_TOOLBAR-TEXT": "No frame",
  "FORMAT_NODE_TOOLBAR-TEXT-COLOR": "Font color",
  "FORMAT_NODE_TOOLBAR-TEXT-POSITION": "Text Layout",
  "FORMAT_NODE_TOOLBAR-UNDER": "Under",
  "FOUND_IN": "Found in: ",
  "FREE_EDGE": "Free edge",
  "FROM-CAMERA": "From camera",
  "FROM-GOOGLEDRIVE": "From Google Drive",
  "FROM-GOOGLEIMAGES": "From Google images",
  "FROM-LOCAL": "From local",
  "FROM-URL": "From URL",
  "FROM_GD": "From Google Drive",
  "FROM_LINK": "From link",
  "FULLNAME": "Full name",
  "FULLSCREEN": "Go to fullscreen view",
  "FULLSCREEN-EXIT": "Go to window view",
  "GATEWAY_TIMEOUT": "Gateway timeout",
  "GD3P_TEXT_01": "There were problems accessing yout map on Google Drive.",
  "GD3P_TEXT_02": "This is not a SMX studio error.",
  "GD3P_TEXT_03": "Your domain administrator disabled 3rd party apps.",
  "GD3P_TEXT_04": "Please contact your domain administrator to activate 3rd party apps in Google Drive.",
  "GD3P_TEXT_05": "For further technical information click this <a href=\"https://support.google.com/a/answer/6105699?hl=en\">link</a>.",
  "GD3P_TITLE": "ERROR ACCESSING MAP",
  "GDNFU_TEXT_01": "You're not using first logged user on <b>Google</b>!",
  "GDNFU_TEXT_02": "Due to a <b>Google Drive</b> library limitation",
  "GDNFU_TEXT_03": "you have to logout from all your logged <b>Google</b> accounts",
  "GDNFU_TEXT_04": "and login with current user:",
  "GDNFU_TEXT_05": "Alternatively, you can use the integrated sharing dialog",
  "GDNFU_TEXT_06": "directly on <b>Google Drive</b> pages.",
  "GDRIVE_NEW_FILE_ERROR_GENERIC_MAP_NEW": "Can't create the map",
  "GDRIVE_NEW_TITLE": "Creating new map...",
  "GDRIVE_OPEN_FILE_ERROR_GENERIC_MAP_OPEN": "Can't open the map",
  "GDRIVE_OPEN_TITLE": "Importing document...",
  "GDRIVE_PICKER_BACK_TO_HOME": "Back to home",
  "GDRIVE_PICKER_ERROR_GENERIC_MAP_OPEN": "Can't open the document",
  "GDRIVE_PICKER_ERROR_LOADING_PICKER": "Can't access Google Drive",
  "GDRIVE_PICKER_TITLE": "Choose file",
  "GENERAL_CANCEL": "Cancel",
  "GENERAL_OK": "Ok",
  "GENERIC_TOOLBAR-BACKGROUND-COLOR": "Color map background",
  "GENERIC_TOOLBAR_ARRANGE": "Arrange Map",
  "GENERIC_TOOLBAR_CHANGE-BACKGROUND-COLOR": "Change background color",
  "GENERIC_TOOLBAR_GRID": "Grid",
  "GENERIC_TOOLBAR_INSERT_NEW": "Insert",
  "GENERIC_TOOLBAR_INSERT_NEW_NODE": "Add new node",
  "GENERIC_TOOLBAR_INSERT_NEW_TABLE": "Add new table",
  "GENERIC_TOOLBAR_MATH_EDITOR": "Math Editor",
  "GENERIC_TOOLBAR_TABLE": "Table",
  "GENERIC_TOOLBAR_TABLE-SIZE": "Table Size",
  "GEOMETRY_LABEL": "Geometry",
  "GE_CODE": "Error code",
  "GE_TEXT_01": "An error occurred while using SMX studio",
  "GE_TEXT_02": "To restore it you can try to do one of these actions:",
  "GE_TEXT_03": "• Check that you have a working internet connection",
  "GE_TEXT_04": "• Reload the page (F5)",
  "GE_TEXT_05": "• Exit SMX studio (logout) and re-enter (login)",
  "GE_TEXT_06": "Press OK to close this message",
  "GOOGLE": "Google",
  "GOOGLE_DOC": "Google Document",
  "GOOGLE_DOC_CREATED": "Google document created!",
  "GOOGLE_DOC_MENU": "Google Document created",
  "GOOGLE_DOC_UPDATED": "Google document updated!",
  "GOOGLE_EMAIL": "or sign in whith Google",
  "GOOGLE_IMAGES": "Google images",
  "GOOGLE_SIGNIN_MESSAGE": "This user is already present as Google user. Click Ok and login as Google contact.",
  "GOON": "GO ON",
  "GO_TO_HOME": "Return to homepage",
  "GREEK_LABEL": "αβγ",
  "HEADER_ABOUT": "Information",
  "HEADER_ABOUT_DEVICE": "Device info",
  "HEADER_ADMIN": "Manage subscriptions",
  "HEADER_DOWNLOAD": "Download my files",
  "HEADER_ROLE_ADMIN": "Manage data",
  "HEADER_FAQ": "FAQ",
  "HEADER_HOME": "Home",
  "HEADER_INFO": "About the app",
  "HEADER_INFO_COPYRIGHT": "(C)opyright Anastasis Soc. Coop. Soc.",
  "HEADER_LANGUAGE": "Language",
  "HEADER_LINKS": "Links Chrome Touch",
  "HEADER_LINKS_LINUX": "Linux",
  "HEADER_LINKS_MAC": "Mac",
  "HEADER_LINKS_WINDOWS": "Windows",
  "HEADER_LOGOUT": "Logout",
  "HEADER_LOGOUT_SUB": "Logging out from SMX studio will keep you logged in Google",
  "HEADER_MANUAL": "Operational guide",
  "HEADER_MANUAL_URL": "https://manuale.smxstudio.it",
  "HEADER_MAPINTRO": "Video manual",
  "HEADER_PRIVACY": "Privacy and security",
  "HEADER_THEME": "Theme",
  "HEADER_USER": "User",
  "HELP_CENTER": "Help center",
  "HELP_CENTER_FRIDAY": "Friday 9.30 - 12.30",
  "HELP_CENTER_INFO_1": "You can receive assistance from Anastasis by calling the number",
  "HELP_CENTER_INFO_2": "Telephone assistance service hours:",
  "HELP_CENTER_INFO_3": "Alternatively, you can send a message to the Anastasis support center with a description of the problem.",
  "HELP_CENTER_MESSAGE": "Describe the problem you have encountered",
  "HELP_CENTER_MONDAY": "Monday 9.30 - 12.30",
  "HELP_CENTER_SENT_ERROR": "There was a problem sending the message. Try sending it again.",
  "HELP_CENTER_SENT_OK": "The message was sent successfully. We will reply as soon as possible.",
  "HELP_CENTER_THURSDAY": "Thursday 14.30 - 17.30",
  "HELP_CENTER_TUESDAY": "Tuesday 14.30 - 17.30",
  "HELP_CENTER_WEDNESDAY": "Wednesday 9.30 - 12.30",
  "HINT_NEW_PASSWORD": "Insert the new password",
  "HINT_OLD_PASSWORD": "Insert the old password",
  "HINT_REPEAT_PASSWORD": "Repeat new password",
  "HOME_BTN": "Home",
  "HOME_CARDS_VIEW_BTN": "Cards view",
  "HOME_EMPTY_CREATE": "To create new text and map documents",
  "HOME_EMPTY_FILTER": "When they start to be many, use the search filters",
  "HOME_EMPTY_FILTER_TITLE": "Search",
  "HOME_EMPTY_IMPORT": "So you can have your files available inside the Suite",
  "HOME_EMPTY_MANUAL": "See the online how-to guide for more tips",
  "HOME_EMPTY_MANUAL_TITLE": "Need help?",
  "HOME_ERROR_GENERIC_MAP_LOAD": "Can't open the map",
  "HOME_ERROR_GENERIC_MAP_UPLOAD": "Error on uploading document",
  "HOME_ERROR_GENERIC_RECENT": "Can't load recent",
  "HOME_FILTERS_BTN": "Filters",
  "HOME_FILTERS_CLOSE_BTN": "Filters",
  "HOME_FILTERS_DOCUMENTS_LABEL": "files",
  "HOME_FILTERS_REMOVE_ALL": "Clear fiter",
  "HOME_FILTERS_TRASHBIN_LABEL": "Trash",
  "HOME_IMPORT_BTN": "Import",
  "HOME_OWNERSHIP_MINE_LABEL": "Mine",
  "HOME_OWNERSHIP_OTHERS_LABEL": "Others",
  "HOME_PAGINATOR": {
    "ITEMS_PER_PAGE": " Elements per page:",
    "NEXT_PAGE": "Next page",
    "PREVIOUS_PAGE": "Previous page",
    "FIRST_PAGE": "First page",
    "LAST_PAGE": "Last page",
    "RANGE_PAGE_EMPTY": "0 of {{length}} files",
    "NO_FILES": "No files",
    "RANGE_PAGE_WITH_PAGES": "{{current}} of {{totalPages}} pages ({{totalFiles}} files)"
  },
  "WORKSPACE_PAGINATOR": {
    "ITEMS_PER_PAGE": " Elements per page:",
    "NEXT_PAGE": "Next page",
    "PREVIOUS_PAGE": "Previous page",
    "FIRST_PAGE": "First page",
    "LAST_PAGE": "Last page",
    "RANGE_PAGE_EMPTY": "0 of {{length}} files",
    "NO_FILES": "No files",
    "RANGE_PAGE": "{{current}} of {{totalPages}} pages ({{totalFiles}} files)"
  },
  "HOME_SEARCH_PLACEHOLDER": "Search",
  "HOME_SORT_ALPHA_BTN": "Alphabetical order",
  "HOME_SORT_DATE_BTN": "Recent first",
  "HOME_TABLE_VIEW_BTN": "Table view",
  "HOME_TITLE": "Home",
  "IC_BTN_WEBSITE_PRIVATE": "Buy as private",
  "IC_BTN_WEBSITE_SCHOOL": "Discover school offers",
  "IC_DEMO_REQUEST_BUTTON": "Request trial",
  "IC_LOGIN_BUTTON": "Go to login",
  "IC_LOGOUT": "Do you want to log in with another user?",
  "IC_LOGOUT_BUTTON": "Back to login",
  "IC_REQUEST_DEMO_1": "Try SMX studio free for 30 days with all features",
  "IC_REQUEST_DEMO_2": "At the end of the demonstration period you can decide to purchase a subscription.",
  "IC_SUBTITLE": "To use SMX studio you need a subscription",
  "IC_TITLE": "Access to SMX studio has been denied because you don't have any subscriptions.",
  "IC_USER_EMAIL": "that will be able to login using email",
  "IC_USER_NAME": "The demonstration will be activated for user",
  "IC_USER_NAME_EMAIL": "The demonstration will be activated for user that will be able to login using email",
  "IC_USER_TYPE": "Please select your user type",
  "IC_USER_TYPE_": "Not set",
  "IC_USER_TYPE_ASL": "ASL",
  "IC_USER_TYPE_DOPOSCUOLA": "After-school operator",
  "IC_USER_TYPE_EDUCATORE": "Educator",
  "IC_USER_TYPE_FIGURA_CLINICA": "Clinical figure",
  "IC_USER_TYPE_INSEGNANTE": "Teacher",
  "IC_USER_TYPE_LOGOPEDISTA": "Speech terapist",
  "IC_USER_TYPE_PRIVATO": "Private",
  "IC_USER_TYPE_SCUOLA": "School",
  "IC_USER_TYPE_TITLE": "User type",
  "IC_USER_TYPE_UNIVERSITA": "University",
  "IC_WEBSITE": "Go to the SMX studio website where you can see prices and offers and buy your subscription.",
  "IMAGE": "Image",
  "IMAGEEDITOR_ELLIPSE": "Ellipse",
  "IMAGEEDITOR_LINE": "Line",
  "IMAGEEDITOR_RECTANGLE": "Rectangle",
  "IMAGEEDITOR_REPLACEIMAGE_MESSAGE": "There is an image in the image editor. Do you want to replace it?",
  "IMAGE_COPIED": "Map image copied in clipboard",
  "IMAGE_NODE": "Node image",
  "IMAGE_NOT_COPIED": "ERROR DURING MAP COPY!",
  "IMAGE_PASTE_BTN": "Paste image",
  "IMAGE_TOOLBAR": "Insert images",
  "IMGEDITOR_ANNOTATIONS": "Annotations",
  "IMGEDITOR_APPLY": "Apply",
  "IMGEDITOR_BACK": "Back",
  "IMGEDITOR_CANCEL": "Cancel",
  "IMGEDITOR_CLEAR": "Cancel image",
  "IMGEDITOR_COPY": "Copia",
  "IMGEDITOR_CROP": "Crop and Transform",
  "IMGEDITOR_DOWNLOAD": "Download",
  "IMGEDITOR_EDITTEXT": "Edit Text",
  "IMGEDITOR_FILLCOLOR": "Fill color",
  "IMGEDITOR_FILTERCHROME": "Chrome",
  "IMGEDITOR_FILTERCOLD": "Cold",
  "IMGEDITOR_FILTERDEFAULT": "Default",
  "IMGEDITOR_FILTERGRAYSCALE": "Grayscale",
  "IMGEDITOR_FILTERINVERT": "Invert",
  "IMGEDITOR_FILTERSEPIA": "Sepia",
  "IMGEDITOR_FILTERWARM": "Warm",
  "IMGEDITOR_FONTCOLOR": "Font Color",
  "IMGEDITOR_INSERT": "Paste image in the document",
  "IMGEDITOR_OPEN": "Import image",
  "IMGEDITOR_PASTE": "Incolla",
  "IMGEDITOR_PEN": "Pen",
  "IMGEDITOR_PENCOLOR": "Color",
  "IMGEDITOR_REDO": "Redo",
  "IMGEDITOR_REMOVE": "Remove",
  "IMGEDITOR_ROTATELEFT": "Rotate left",
  "IMGEDITOR_ROTATERIGHT": "Rotate right",
  "IMGEDITOR_STROKECOLOR": "Stroke color",
  "IMGEDITOR_TEXT": "Text",
  "IMGEDITOR_UNDO": "Undo",
  "IMPORTS_PDF": "Load PDF",
  "IMPORT_DESCRIPTION": "Choose a .sme file from your local disk and import it into SMX studio",
  "INFORMATION": "Information",
  "INPUT-IMAGE-URL": "Paste Image url",
  "INPUT_DOCNAME": "Name",
  "INPUT_LINK_URL": "Insert link URL",
  "INPUT_LINK_URL_PREVIEW": "Insert link only (no image and title on node)",
  "INSERT": "Insert",
  "INSERT-ATTACHMENT": "Insert attachment",
  "INSERT-IMAGE": "Insert image",
  "INSERT_BLOCKNOTES": "Insert in block notes",
  "INSERT_DEEP": "Insert in deep",
  "INSERT_IMAGE": "Insert image",
  "INSERT_IN_DOCUMENT": "Insert in document",
  "INSERT_IN_MAP": "Insert in map",
  "INSERT_LINK": "Insert link",
  "INSERT_LINK_PDF": "or insert link",
  "INSERT_MATH": "Mathematics",
  "INSERT_NEW_PASSWORD": "Insert new password",
  "INSERT_PASSWORD": "Insert your password",
  "INSERT_TEXT": "Insert text",
  "INSUFFICIENT_FILE_PERMISSIONS": "The user does not have sufficient permissions for file",
  "INVALID_PDF": "This file is not a valid PDF",
  "INVALID_URL": "Invalid url",
  "ITEMS_PER_PAGE_LABEL": "Per page:",
  "LANGUAGE_TOOLBAR": "Language",
  "LAST_PAGE_LABEL": "Last page",
  "LIABILITY_CONTENT": "<br/><h2><b>Declaration of responsibility for contents</b></h2><div><p>I declare that I take legal responsibility for the contents that I will insert and share in SMX studio.</p></div>",
  "LIABILITY_ERROR": "Required",
  "LINE": "Line",
  "LINKED_DOCS_DELETED": "Side by side removed",
  "LINKS": "Links",
  "LINKS-GOOGLE-DRIVE": "From Google Drive",
  "LINKS-MAP": "Map",
  "LINKS-VIDEO": "Video",
  "LINK_ADDED_MSG": "Link added",
  "LINK_ASSISTANCE": "technical assistance",
  "LINK_COPIED": "Link copied in clipboard",
  "LINK_REMOVED_MSG": "Link removed",
  "LINK_UNAVAILABLE": "Link is not available",
  "LINK_WITH_GOOGLE": "Link with Google",
  "LOCK_DOC": "Lock document",
  "LOGIN": "Login",
  "LOGIN_COMMAND_LOGIN": "Login with Google",
  "LOGIN_COOKIES_INFO": "How to enable third-part cookies",
  "LOGIN_COOKIES_URL": "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en&oco=0",
  "LOGIN_DISCOVER_MORE": "Discover more",
  "LOGIN_DOWNLOAD_APP": "Download the App:",
  "LOGIN_ERROR_GENERIC": "Error authenticating user",
  "LOGIN_FIRST_1": "Is this your first login?",
  "LOGIN_FIRST_2": "Consult in preview the documents related to our",
  "LOGIN_LINK_PRIVACY": "Privacy policy",
  "LOGIN_MAPS_AND_MORE": "MAPS and more",
  "LOGIN_MOBILE_1": "SMX studio operation is not guaranteed",
  "LOGIN_MOBILE_2": "using the browser of a mobile device",
  "LOGIN_MOBILE_MESSAGE": "SMX studio operation is not assured if you use a mobile device browser.",
  "LOGIN_MOBILE_WARNING": "WARNING",
  "LOGIN_NEEDS_GOOGLE_ACCOUNT": "An active SMX studio subscription is required.",
  "LOGIN_SUBSCRIPTION": "You don't have an active SMX studio subscription yet?",
  "LOGIN_TITLE": "Login",
  "LOGIN_TITLE_DEMO": "Activate demonstration",
  "LOGIN_UNDER_DRAW": "Draw",
  "LOGIN_UNDER_MAPS": "Maps",
  "LOGIN_UNDER_MATH": "Math",
  "LOGIN_UNDER_NOTEPAD": "Notepad",
  "LOGIN_UNDER_OUTLINE": "Outline",
  "LOGIN_UNDER_PDF": "PDF",
  "LOG_EXP_LABEL": "Logarithms and Exponentials",
  "MADE_WITH": "made with SMX studio (C) Anastasis Soc.Coop.Soc.",
  "MAIL_SENT": "Email sent",
  "MAINTENANCE": "Maintenance",
  "MAIN_MENU_ARRANGE": "Arrange",
  "MAIN_MENU_ARRANGE-ALIGN": "Align",
  "MAIN_MENU_ARRANGE-ALIGN-BOTTOM": "Bottom",
  "MAIN_MENU_ARRANGE-ALIGN-HORZCENTER": "Center (horizontal)",
  "MAIN_MENU_ARRANGE-ALIGN-LEFT": "Left",
  "MAIN_MENU_ARRANGE-ALIGN-RIGHT": "Right",
  "MAIN_MENU_ARRANGE-ALIGN-TOP": "Top",
  "MAIN_MENU_ARRANGE-ALIGN-VERTCENTER": "Center (vertical)",
  "MAIN_MENU_ARRANGE-ORDER": "Order",
  "MAIN_MENU_ARRANGE-ORDER-BRINGTOFRONT": "Bring to front",
  "MAIN_MENU_ARRANGE-ORDER-SENDTOBACK": "Send to back",
  "MAIN_MENU_ARRANGE-SIZE": "Size",
  "MAIN_MENU_ARRANGE-SIZE-SAMEHEIGHT": "Same height",
  "MAIN_MENU_ARRANGE-SIZE-SAMESIZE": "Same size",
  "MAIN_MENU_ARRANGE-SIZE-SAMEWIDTH": "Same width",
  "MAIN_MENU_EDIT": "Edit",
  "MAIN_MENU_EDIT-BACKGROUND": "Background color",
  "MAIN_MENU_EDIT-COPY": "Copy",
  "MAIN_MENU_EDIT-COPY-ALL": "Copy all",
  "MAIN_MENU_EDIT-COPY-DEEP": "Copy deep text",
  "MAIN_MENU_EDIT-COPY-IMAGE": "Copy image",
  "MAIN_MENU_EDIT-COPY-LINK": "Copy attachment",
  "MAIN_MENU_EDIT-COPY-MAP-IMAGE": "Copy map image",
  "MAIN_MENU_EDIT-COPY-TEXT": "Copy text",
  "MAIN_MENU_EDIT-CUT": "Cut",
  "MAIN_MENU_EDIT-DELETE": "Delete",
  "MAIN_MENU_EDIT-PASTE": "Paste",
  "MAIN_MENU_EDIT-REDO": "Redo",
  "MAIN_MENU_EDIT-TEXT": "Node title",
  "MAIN_MENU_EDIT-UNDO": "Undo",
  "MAIN_MENU_FILE": "File",
  "MAIN_MENU_FILE-COPY-MAP": "Create a copy",
  "MAIN_MENU_FILE-CREATE-A-COPY": "Create a copy...",
  "MAIN_MENU_FILE-CREATE-A-DOC": "Create a Google document",
  "MAIN_MENU_FILE-DOC": "Google document created",
  "MAIN_MENU_FILE-EXPORT": "Download as...",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX": "Document (Docx)",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX-LO": "for LibreOffice",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX-MS": "for Microsoft Office",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-PDF": "Document (PDF)",
  "MAIN_MENU_FILE-EXPORT-TO-IMAGE": "Image (jpg)",
  "MAIN_MENU_FILE-EXPORT-TO-IMAGE-PDF": "Image (PDF)",
  "MAIN_MENU_FILE-EXPORT-TO-IMAGE-QRCODES": "Image + QRcodes (jpg)",
  "MAIN_MENU_FILE-EXPORT-TO-MAP": "Map (sme)",
  "MAIN_MENU_FILE-IMPORT-MAP": "Import map",
  "MAIN_MENU_FILE-LIM-KEYBOARD": "Keyboard",
  "MAIN_MENU_FILE-LIM-ONLY-TOUCH": "Touch",
  "MAIN_MENU_FILE-LIM-PREFERENCES": "Interactive Whiteboard",
  "MAIN_MENU_FILE-NEW-MAP": "New map",
  "MAIN_MENU_FILE-OPEN-DOC": "Open document",
  "MAIN_MENU_FILE-OPEN-MAP": "Open",
  "MAIN_MENU_FILE-OPEN-TAGS": "Tags",
  "MAIN_MENU_FILE-PREFERENCES": "Settings",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER": "Image filter",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-ALL": "All the images",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE": "Free to use",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-COM": "Free to use, also commercial",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-MOD": "Free to use and modify",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-MOD-COM": "Free to use and modify, also commercial",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-SAFESEARCH": "Safe search: ACTIVE",
  "MAIN_MENU_FILE-PREFERENCES-PRINT": "Print quality",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-DRAFT": "Draft",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-HIGH": "High",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-MAXIMUM": "Maximum",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-NORMAL": "Normal",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-VERYHIGH": "Very high",
  "MAIN_MENU_FILE-PREFERENCES_USER": "User settings",
  "MAIN_MENU_FILE-PRINT": "Print",
  "MAIN_MENU_FILE-PRINT-MAP": "Map",
  "MAIN_MENU_FILE-PRINT-MAP-QRCODES": "Map + QRcodes",
  "MAIN_MENU_FILE-RENAME": "Rename",
  "MAIN_MENU_FILE-REVISION-HISTORY": "History",
  "MAIN_MENU_FILE-SHARE": "Share",
  "MAIN_MENU_FILE-SHOW-MAP": "Show mappa",
  "MAIN_MENU_FILE-TEXT-BACKCOLOR": "Highlighter",
  "MAIN_MENU_FILE-TEXT-COLOR": "Font color",
  "MAIN_MENU_FILE-TEXT-PREFERENCES": "Text",
  "MAIN_MENU_FILE-TOUCH-PREFERENCES": "Enable touch",
  "MAIN_MENU_FILE-UPDATE-DOC": "Update document",
  "MAIN_MENU_FILE-VIEW-MAP": "View mappa",
  "MAIN_MENU_FILE_MAP-LANGUAGE": "Map Language",
  "MAIN_MENU_FIX": "Fix",
  "MAIN_MENU_FIXED": "Document fixed",
  "MAIN_MENU_FORMAT": "Format",
  "MAIN_MENU_FORMAT-ARROW": "Arrow",
  "MAIN_MENU_FORMAT-ARROW-BREAKARROW": "Break arrow",
  "MAIN_MENU_FORMAT-ARROW-COLOR": "Line color",
  "MAIN_MENU_FORMAT-ARROW-LEFTARROW": "Left tip",
  "MAIN_MENU_FORMAT-ARROW-RIGHTARROW": "Right tip",
  "MAIN_MENU_FORMAT-ARROW-STRAIGHTEN": "Straighten arrow",
  "MAIN_MENU_FORMAT-ARROW-THICKNESS": "Line thickness",
  "MAIN_MENU_FORMAT-NODE": "Node",
  "MAIN_MENU_FORMAT-NODE-BACKCOLOR": "Background color",
  "MAIN_MENU_FORMAT-NODE-COLOR": "Line color",
  "MAIN_MENU_FORMAT-NODE-DELETEIMAGE": "Delete image",
  "MAIN_MENU_FORMAT-NODE-IMAGEFRAME": "Add/Remove frame",
  "MAIN_MENU_FORMAT-NODE-SHAPE": "Node shape",
  "MAIN_MENU_FORMAT-NODE-TEXTLAYOUT": "Text layout",
  "MAIN_MENU_FORMAT-NODE-THICKNESS": "Shape thickness",
  "MAIN_MENU_FORMAT-TABLE": "Table",
  "MAIN_MENU_FORMAT-TABLE-DELETECOL": "Delete column",
  "MAIN_MENU_FORMAT-TABLE-DELETEROW": "Delete row",
  "MAIN_MENU_FORMAT-TABLE-DELETETABLE": "Delete table",
  "MAIN_MENU_FORMAT-TABLE-INSERTCOLAFTER": "Insert column after",
  "MAIN_MENU_FORMAT-TABLE-INSERTCOLBEFORE": "Insert column before",
  "MAIN_MENU_FORMAT-TABLE-INSERTROWOVER": "Insert row over",
  "MAIN_MENU_FORMAT-TABLE-INSERTROWUNDER": "Insert row under",
  "MAIN_MENU_FORMAT-TEXT": "Text",
  "MAIN_MENU_FORMAT-TEXT-BACKCOLOR": "Highlighter color",
  "MAIN_MENU_FORMAT-TEXT-COLOR": "Font color",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS": "Effects",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-BOLD": "Bold",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-ITALIC": "Italic",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-SUBSCRIPT": "Subscript",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-SUPERSCRIPT": "Superscript",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-UNDERLINE": "Underline",
  "MAIN_MENU_FORMAT-TEXT-FONT": "Font type",
  "MAIN_MENU_FORMAT-TEXT-FONTSIZE": "Size",
  "MAIN_MENU_FORMAT-TEXT-LANGUAGE": "Selecion language",
  "MAIN_MENU_INSERT": "Insert",
  "MAIN_MENU_INSERT-DEEPTEXT": "Deep text",
  "MAIN_MENU_INSERT-LINK": "Link",
  "MAIN_MENU_INSERT-LINK-GOOGLE-DRIVE": "From Google Drive",
  "MAIN_MENU_INSERT-LINK-MAP": "Map",
  "MAIN_MENU_INSERT-NODE": "Node",
  "MAIN_MENU_INSERT-QUICKEDIT": "Quick insert",
  "MAIN_MENU_INSERT-QUICKSPEECH-CLOSE": "Disable dictation",
  "MAIN_MENU_INSERT-QUICKSPEECH-OPEN": "Enable dictation",
  "MAIN_MENU_INSERT-TABLE": "Table",
  "MAIN_MENU_TOOLS": "Tools",
  "MAIN_MENU_UNFIX": "Unfix",
  "MAIN_MENU_UNFIXED": "Document unfixed",
  "MAIN_MENU_VIEW": "View",
  "MAIN_MENU_VIEW-CLOSE-NODES": "Close all nodes",
  "MAIN_MENU_VIEW-FIT": "Fit view",
  "MAIN_MENU_VIEW-GRID": "Grid",
  "MAIN_MENU_VIEW-OPEN-NODES": "Open all nodes",
  "MAIN_MENU_VIEW-QRCODE": "QR code",
  "MAIN_MENU_VIEW-QRCODE-GDOC": "Google Document",
  "MAIN_MENU_VIEW-QRCODE-MAP": "Map",
  "MAIN_MENU_VIEW-ZOOM-100": "Zoom 100%",
  "MAIN_MENU_VIEW-ZOOM-IN": "Zoom in",
  "MAIN_MENU_VIEW-ZOOM-OUT": "Zoom out",
  "MAIN_TOOLBAR_ADD_TOOLS": "Additional tools",
  "MAIN_TOOLBAR_BLOCKNOTES": "Block notes",
  "MAIN_TOOLBAR_CHAT": "Chat",
  "MAIN_TOOLBAR_CLEARREADORDER": "Clear",
  "MAIN_TOOLBAR_CLOSE_NODES": "Restart map show",
  "MAIN_TOOLBAR_DEFAULTREADORDER": "Default read order",
  "MAIN_TOOLBAR_EDITSHOW": "Edit",
  "MAIN_TOOLBAR_EXPORT-TO-IMAGE": "Download as image",
  "MAIN_TOOLBAR_EXPORT-TO-SME": "Download as sme",
  "MAIN_TOOLBAR_EXTRA": "Extra",
  "MAIN_TOOLBAR_FIND": "Find in document",
  "MAIN_TOOLBAR_GOTOEDITMODE": "Go back to map",
  "MAIN_TOOLBAR_HISTORY": "Revisions",
  "MAIN_TOOLBAR_INTERACTION_MODE": "Hand mode",
  "MAIN_TOOLBAR_MODIFYTEXT": "Modify text",
  "MAIN_TOOLBAR_OPEN_NODES": "Show whole map",
  "MAIN_TOOLBAR_OUTLINE": "Outline",
  "MAIN_TOOLBAR_PDF": "PDF",
  "MAIN_TOOLBAR_QRCODE": "Share with QRcode",
  "MAIN_TOOLBAR_QUICKEDIT": "Quick edit",
  "MAIN_TOOLBAR_REDO": "Redo",
  "MAIN_TOOLBAR_SEARCHWEB": "Search on web",
  "MAIN_TOOLBAR_SHARE-FB": "Share on Facebook",
  "MAIN_TOOLBAR_SHARE_CLASSROOM": "Share on Google Classroom",
  "MAIN_TOOLBAR_SHOWHELP_ADD": "click on node to add a step",
  "MAIN_TOOLBAR_SHOWHELP_REMOVE": "click the number to remove the step",
  "MAIN_TOOLBAR_SPEECHEDIT": "Speech edit",
  "MAIN_TOOLBAR_STARTSHOW": "Start",
  "MAIN_TOOLBAR_TEXT-TO-SPEECH-ENABLE": "Enable text to speech",
  "MAIN_TOOLBAR_UNDO": "Undo",
  "MAIN_TOOLBAR_ZOOM-FIT": "Fit map",
  "MAIN_TOOLBAR_ZOOM_IN": "Zoom in",
  "MAIN_TOOLBAR_ZOOM_OUT": "Zoom out",
  "MAIN_TOOLBAR_ZOOM_SELECTION": "Zoom on selection",
  "MAIN_TOOLBAT_TEXT-TO-SPEECH-DISABLE": "Disable text to speech",
  "MANAGE_SHARINGS_MAP": "Advanced sharing",
  "MAPEDIT_ERROR_GENERIC_MAP_LOAD": "Can't open the map",
  "MAPEDIT_LOADING": "Loading...",
  "MAPEDIT_TITLE": "Map",
  "MAPSHARED_TITLE": "Map",
  "MAPVIEW_TITLE": "Map",
  "MAP_AUTH": "Auth",
  "MAP_DELETEDATE": "Deletion",
  "MAP_LASTUPDATE": "Last update",
  "MAP_NAME": "Name",
  "MAP_PUBLIC": "public",
  "MAP_SHARING": "Sharing",
  "MAP_VIEW_VIEW_BUTTON": "View Only",
  "MAP_VIEW_VIEW_BUTTON_MESSAGE": "You can only view this map. Make a copy if you want to edit it",
  "MATH_ADVANCED_KEYBOARD_DESC": "Select the additional keyboards you would like to use.",
  "MATH_ADVANCED_KEYBOARD_TITLE": "Advanced keyboards",
  "MATH_AI_CHECK": "AI Check (Beta)",
  "MATH_AI_CHECK_DESC1": "This is an AI feature that allows you to check the correctness of a mathematical expression.",
  "MATH_AI_CHECK_DESC2": "It is important to note that this feature is still in Beta testing and may not always provide accurate results. Generative AI is a powerful tool, but it is not infallible: it can make mistakes and provide incorrect answers. Therefore, it is always advisable to verify the results obtained through this feature.",
  "MATH_AI_CHECK_ERROR": "Math AI Check failed",
  "MATH_AI_CHECK_OK": "Math AI Check OK",
  "MATH_ANALYSIS_KEYBOARD": "Analysis",
  "MATH_BASIC_KEYBOARD": "Base",
  "MATH_CANCEL": "Delete",
  "MATH_CHECK_MANUAL": "Check the manual to learn more.",
  "MATH_CLOSE": "Close",
  "MATH_DISEQUATIONS_KEYBOARD": "Disequations",
  "MATH_DUPLICATE": "Duplicate line",
  "MATH_ERROR_FORMULA": "Error in formula",
  "MATH_ERROR_FORMULA_PLACEHOLDER": "One or more placeholders need to be filled.",
  "MATH_ERROR_IMAGE": "Error generating the image",
  "MATH_GEOMETRY_KEYBOARD": "Geometry",
  "MATH_GREEK_KEYBOARD": "αβγ",
  "MATH_LATEX": "LaTeX",
  "MATH_LATEX_INFO": "Information about using LaTeX",
  "MATH_LATEX_INFO_MESSAGE": "<div><b>How to enter LaTeX mode</b><br/>Click the <b>Enter LaTeX Mode</b> option in the context menu to convert all mathematical content to LaTeX, or press the <b>\\</b> key on your keyboard to start writing in LaTeX from your current position.</div><br/> <div><b>How to get suggestions</b><br/>Once in LaTeX mode, press the <b>\\</b> key on your keyboard and start typing in LaTeX.</div><br/> <div><b>How to select a suggestion</b><br/>Use the <b>arrow keys</b> to move through the available options and press <b>TAB</b> to insert the selected item into the current formula.</div><br/> <div><b>How to exit LaTeX mode</b><br/>There are several ways: <ul> <li>Select the <b>Exit LaTeX Mode</b> option in the context menu</li> <li>Press the <b>ESC</b> key on your keyboard</li> </ul> </div>",
  "MATH_LOG_EXP_KEYBOARD": "Logarithms and Exponentials",
  "MATH_NEW": "New formula",
  "MATH_OK": "Insert",
  "MATH_OK_ALL": "Insert as one item",
  "MATH_OK_SEPARATE": "Insert as separate items",
  "MATH_OK_SINGLE": "Insert this line",
  "MATH_PHYSICS_KEYBOARD": "Physics",
  "MATH_PRIMARY_KEYBOARD": "Primary",
  "MATH_PRIMARY_SCHOOL_KEYBOARD_DESC": "The recommended keyboard for primary school is the basic keyboard.",
  "MATH_PRIMARY_SCHOOL_KEYBOARD_TITLE": "Primary school",
  "MATH_SETS_KEYBOARD": "Sets and logic",
  "MATH_TRIGONOMETRY_KEYBOARD": "Trigonometry",
  "MATH_SIMPLIFY": "Simplify",
  "MATH_UNSIMPLIFY": "Delete simplification",
  "MATH_BOX": "Box",
  "MATH_UNBOX": "Remove box",
  "MAX_ERROR": "The maximum number of users that can be enabled is 500",
  "MESSAGE_FILE_DETETED": " The document does not exist or is no longer available. We advice you to remove the attachment associated with this node to avoid future errors.",
  "MESS_GOOGLE_ACCOUNT_1": "Having signed in through Google with the email address ",
  "MESS_GOOGLE_ACCOUNT_2": "SMX studio is automatically connected to your Google Drive.",
  "MESS_GOOGLE_ACCOUNT_3": "You can edit your profile fields from your Google Account.",
  "MIN_ERROR": "The number of allowed users is lesser than the assigned users.",
  "MODALITY": "Modality",
  "MOVE_HERE": "Move to",
  "MOVE_MAPS": "Move maps",
  "MOVE_MAPS_NEWUSER": "New user ID (to)",
  "MOVE_MAPS_OLDUSER": "Old user ID (from)",
  "MSG_ASK_CHANGE_NODE_DOC": "The node already contains text or image. Do you want to change it with document contents?",
  "MSG_ASK_CHANGE_NODE_LINK": "The node already contains text or image. Do you want to change it with link contents?",
  "MSG_ASK_CHANGE_NODE_MAP": "The node already contains text or image. Do you want to change it with map contents?",
  "MSG_BLOCKED_POPUP": "Popups are blocked on your browser, click su ok to open the document",
  "MSG_DELETED_MAP": "Map has beed deleted",
  "MSG_DOCUMENT_NOT_FOUND": "Document not found",
  "MSG_ERROR": "Error",
  "MSG_ERROR_CAPTURE": "Ooops! Something went wrong while capturing the image.",
  "MSG_ERROR_CAPTURE_2": "An error occurred during the operation.",
  "MSG_MAP_DOES_NOT_EXIST": "This map has never been opened in SMX studio. You have to open it first to use as a link.",
  "MSG_MISSING_PRIVACY_TEXT": "You have not yet given consent to the processing of personal data.<br>Press Ok to log in again and be sure to fill in the privacy consent form.",
  "MSG_MISSING_PRIVACY_TITLE": "Privacy missing",
  "MSG_NO_VIDEOREC_SUPPORTED": "The video recorder is only supported on <b>Windows</b>.",
  "MSG_OCRSCAN_ERROR_DECREASE_SCANCOUNT": "Error decreasing scan counter.",
  "MSG_OCRSCAN_ERROR_MATHPIX": "Error during server call.",
  "MSG_OCRSCAN_ERROR_SEARCH_SCANCOUNT": "Error searching scan counter.",
  "MSG_OCRSCAN_GENERIC_ERROR": "Generic OCR error.",
  "MSG_OCRSCAN_NO_SCANS_LEFT": "You have no more scans left.",
  "MSG_OCRSCAN_OK": "Scan ok.",
  "MSG_REMOVED_MAP": "Map has been removed from list",
  "MSG_TRASHED_MAP": "Map has been trashed",
  "MSG_UNTRASHED_MAP": "Map has been restored",
  "MSG_USER_CANT_SHARE": "You don't have permission to share this map",
  "MSG_VIDEOREC_INFO_01": "SMX studio Video Recorder",
  "MSG_VIDEOREC_INFO_02": "Recording video service and cloud space are supplied by <a href='https://www.apowersoft.com/', target='_blank'>Apowersoft Ltd</a>.",
  "MSG_VIDEOREC_INFO_03": "Anastasis does not give assistance or guarantees on this service.",
  "MSG_VIDEOREC_INFO_04": "To use this video recorder you need to <b>install the launcher</b>.",
  "MSG_VIDEOREC_INFO_05": "1. Click [<b>Record video</b>] to start the recorder.",
  "MSG_VIDEOREC_INFO_06": "2. <i>Customize</i> recording modes, then click [<b>REC</b>] to start recording.",
  "MSG_VIDEOREC_INFO_07": "3. When you're done, click on [<b>STOP</b>] button and [<b>SAVE</b>] the video.",
  "MSG_VIDEOREC_INFO_08": "You can find more information about using the video recorder in SMX studio manual.",
  "MSG_VIDEOREC_SUB_01": "Full screen",
  "MSG_VIDEOREC_SUB_02": "Area",
  "MSG_VIDEOREC_SUB_03": "System audio",
  "MSG_VIDEOREC_SUB_04": "Webcam",
  "MULTI_STATS": "SMX studio - Statistics",
  "MULTI_STATS_PAGINATOR": {
    "ITEMS_PER_PAGE": "Users per page:",
    "NEXT_PAGE": "Next page",
    "PREVIOUS_PAGE": "Previous page",
    "FIRST_PAGE": "First page",
    "LAST_PAGE": "Last page",
    "RANGE_PAGE_EMPTY": "0 of {{length}} users",
    "RANGE_PAGE": "{{start}} – {{end}} of {{total}} users"
  },
  "MULTI_STATS_USERS": "Show users",
  "MULTI_STATS_VISIBILITY": "Visible only to you, as the administrator",
  "MULTI_STATS_WHO": "Contents overview for subscription",
  "MY_MAPS": "Mine",
  "MY_PDF": "My PDF",
  "NEWSLETTER_CONTENT_1": "<h2><b>Subscribe to the newsletter</b></h2>",
  "NEWSLETTER_CONTENT_2": "Subscribe to the newsletter to stay updated on the latest Anastasis news.",
  "NEWSLETTER_DIALOG_TITLE": "Subscribe to the newsletter",
  "NEWSLETTER_INFO": "Info about the newsletter",
  "NEW_DOC": "New document",
  "NEW_MAP": "New map",
  "NEW_MAP_NAME": "New map",
  "NEW_TAG": "New tag",
  "NEXT_PAGE": "Next page",
  "NEXT_PAGE_LABEL": "Next page",
  "NOBROWSER_TITLE": "Incompatible browser",
  "NOCOLOR": "No color",
  "NOTEPAD_READONLY": "Notepad is read only",
  "NOTES": "Notes",
  "NOTIFICATIONS": "Notifs",
  "NOTIFICATIONS_EMPTY": "No notifs",
  "NOTIFICATIONS_FOOTER_BUTTON": "Show all notifications in the last 30 days",
  "NOTIFICATIONS_INFO": "You will receive information on updates, training ...",
  "NOTIFICATIONS_LIST": "Notifs List",
  "NOTIFICATION_CHECK": "Show",
  "NOTIFICATION_DATE": "Event date",
  "NOTIFICATION_DESC": "Description",
  "NOTIFICATION_DESC_PLACEHOLDER": "Insert notification description",
  "NOTIFICATION_EXPIRED_ACCOUNT": "Your subscription has expired",
  "NOTIFICATION_EXPIRED_DEMO": "Your demonstration has expired",
  "NOTIFICATION_EXPIRING_ACCOUNT": "Your subscription is about to expire",
  "NOTIFICATION_EXPIRING_DEMO": "Your demonstration is about to expire",
  "NOTIFICATION_INSERT": "Insert notification",
  "NOTIFICATION_LINK": "Link",
  "NOTIFICATION_MANAGEMENT": "Notification management",
  "NOTIFICATION_OPEN_TOOLTIP": "Open",
  "NOTIFICATION_TITLE": "Title",
  "NOTIFICATION_TITLE_PLACEHOLDER": "Insert notification title",
  "NOTIFICATION_TYPE": "Type",
  "NOT_A_GOOGLE_EMAIL_MSG": " is not a Google email.",
  "NOT_OWNER_CANT_CREATE_GOOGLEDOC": "Only map owner can generate the Google Document",
  "NOT_VALID_DOMAINLICS_MSG": " is not a valid user number.",
  "NOT_VALID_DOMAIN_MSG": " is not a valid domain.",
  "NOT_VALID_EMAIL_MSG": " is not a valid email.",
  "NO_DEMO": "No demo available",
  "NO_DOCS_ALL1": "Here you will find your text documents, PDFs and Maps that you have imported or created",
  "NO_DOCS_ALL2": "Create or import Text, Maps and PDF documents",
  "NO_DOCS_FILTERS": "We couldn't find any documents with your filters",
  "NO_DOCS_SEARCH": "We couldn't find any documents matching your search",
  "NO_DOCS_SEARCH_AND_FILTERS_1": "We couldn't find any documents matching your search. Try searching without filters",
  "NO_DOCS_SEARCH_AND_FILTERS_2": "Try searching without filters",
  "NO_DOCS_TRASH": "THE TRASH BIN IS EMPTY",
  "NO_GOOGLE_MESSAGE_1": "This service is unavailable for users who are under 13 that are managed by parents using Family Link.",
  "NO_GOOGLE_MESSAGE_2": "To solve this problem use an account that is not linked to a Family Link.",
  "NO_GOOGLE_TITLE": "Can't access Google login",
  "NO_MAPS": "No maps yet",
  "NO_MAP_NAME": "Insert map name",
  "NO_NODE_SELECTED": "Select one node",
  "NO_NOTIFICATIONS": "is empty",
  "NO_SUBSCRIPTIONS": "No subscriptions found",
  "NO_TAGS": "Click on the 'New tag' button to start classifying your content. It's simple and will save you time!",
  "NUM_COL": "Number of columns",
  "NUM_ROW": "Number of rows",
  "OCRSCAN": "Math OCR",
  "OCRSCAN_LEFT": "OCR Scans left",
  "OCRSCAN_LEFT_GROUP_1": "Your workgroup has %n scan left",
  "OCRSCAN_LEFT_GROUP_N": "Your workgroup has %n scans left",
  "OCRSCAN_LEFT_PERSONAL_1": "You have %n scan left",
  "OCRSCAN_LEFT_PERSONAL_N": "You have %n scans left",
  "OCRSCAN_OVER": "You have no more scans left",
  "OCRSCAN_PERIOD_ALL": "in total",
  "OCRSCAN_PERIOD_MONTH": "for the current month",
  "OCRSCAN_POLICY_FREE": "in total",
  "OCRSCAN_POLICY_MONTHLY": "monthly for the workgroup",
  "OCRSCAN_POLICY_MONTHLY-USER": "monthly for each user of the group",
  "OCRSCAN_WAIT": "Image is loading, Please wait...",
  "OCR_LATEX_EMPTY": "No recognized mathematical notation",
  "OCR_SCANS_LEFT": "Scans left",
  "OFFLINE_GENERIC": "Don't work without connection",
  "OFFLINE_LOGIN": "Cannot log in without connection",
  "OFFLINE_RECENT": "No recents resource without connection",
  "OFFLINE_STATUS": "Disconnected! The map will be saved as soon as the connection returns",
  "OK": "Ok",
  "OOOPS": "Whoops!",
  "OOPS": "Whoops!!!",
  "OPACITY": "Opacity",
  "OPEN": "Open",
  "OPEN_CENTER": "Open center",
  "OPEN_FROM_DRIVE": "From Google Drive",
  "OPEN_FROM_GDRIVE": "Import from Drive",
  "OPEN_FROM_LOCAL": "Upload map",
  "OPEN_GOOGLE_DOC": "Open Google Doc",
  "OPEN_INTRO_MAP": "Open tutorial map",
  "OPEN_IN_NEW": "Open in a new tab",
  "OPEN_IN_NEW_WINDOW": "Open in new window",
  "OPEN_LEFT": "Open left",
  "OPEN_MATH": "Open math keyboard",
  "OPEN_PDF": "Upload Pdf",
  "OPEN_RECENT_MAP": "Open recent",
  "OPEN_RIGHT": "Open right",
  "OPEN_SIDE": "Open side by side",
  "ORDER-CREATEDBY": "Order created by",
  "ORDER-CREATIONDATE": "Order creation date",
  "ORDER-DOMAINLICS": "Domain users number",
  "ORDER-EXPIRED": "Subscription has expired and you cannot configure it.",
  "ORDER-EXPIREDATE": "Expiry date",
  "ORDER-FULLNAME": "Buyer name",
  "ORDER-HISTORY-DATE": "Date:",
  "ORDER-HISTORY-TITLE": "History for order #",
  "ORDER-LASTMODIFICATIONBY": "Last modification by",
  "ORDER-LASTMODIFICATIONDATE": "Last modification date",
  "ORDER-LICENSETYPE": "License type",
  "ORDER-NOTES": "Order notes",
  "ORDER-NOTFOUND-LINE1": "This subscription does not exist",
  "ORDER-NOTFOUND-LINE2": "This subscription has been disabled",
  "ORDER-NOTFOUND-LINE3": "Limited or missing network connectivity",
  "ORDER-NOTFOUND-LINE4": "Subscription security code does not match",
  "ORDER-NOTFOUND-SUB": "Possible causes are:",
  "ORDER-NOTFOUND-TITLE": "You cannot configure this subscription",
  "ORDER-ORDERID": "Order ID",
  "ORDER-ORIGIN": "Order origin",
  "ORDER-REFORDERID": "Previous order ID",
  "ORDER-SLOTCOUNT": "Users number",
  "ORDER-SUBMITTED-SUB": "Now you may close this tab",
  "ORDER-SUBMITTED-TITLE": "Subscription edit successful",
  "ORDER-SUSPENDED": "Subscription has been deactivated and you cannot configure it.",
  "ORDER-USEREMAIL": "Buyer email",
  "ORDER_BY": "Order by",
  "ORDER_MODIFIED": "Order changed successfully",
  "ORIGIN_AID": "AID entry",
  "ORIGIN_ALL": "--- All orders ---",
  "ORIGIN_APP-STORE": "App Store",
  "ORIGIN_AZIONE-SMX-2020-2021": "Action SMX 2020-2021",
  "ORIGIN_AZIONE-SMX-2021-2022": "Action SMX 2021-2022",
  "ORIGIN_BUY": "Purchase",
  "ORIGIN_DEMO": "Demo",
  "ORIGIN_DOPOSCUOLA": "Afterschool",
  "ORIGIN_DS-SCUOLA-2020": "DS Adopt a school 2020",
  "ORIGIN_FAD": "FAD",
  "ORIGIN_MANUAL": "Manual entry",
  "ORIGIN_PIEM-SPAOLO-2021": "Piemonte-Fond.S.Paolo 2021",
  "ORIGIN_PLAY-STORE": "Play Store",
  "ORIGIN_RETE-ANA-SCUOLA": "Anastasis centre network-SCHOOL",
  "ORIGIN_SMX-SCUOLE-2022": "SMX Schools 2022",
  "ORIGIN_SPAIN": "Spain",
  "ORIGIN_USR-ER": "Reg.school office Emilia Romagna",
  "ORIGIN_WEBINAR": "Webinar",
  "OTHER": "Other",
  "OTHERS_MAPS": "Other",
  "OTHER_LANGUAGES": "Other languages",
  "OUTLINE": "Outline",
  "OUTLINE_ADD_ABOVE": "Add sibling",
  "OUTLINE_ADD_BELOW": "Add child",
  "OUTLINE_ARRANGE": "Arrange map",
  "OUTLINE_ARRANGE_TABLE": "Table",
  "OUTLINE_COPY": "Copy",
  "OUTLINE_DELETE": "Delete node and children",
  "OUTLINE_DOWN": "Move down",
  "OUTLINE_EDIT": "Edit",
  "OUTLINE_IN": "Move in",
  "OUTLINE_NODE_VIEW_IMAGE_HIDE": "Hide images",
  "OUTLINE_NODE_VIEW_IMAGE_SHOW": "Show images",
  "OUTLINE_OUT": "Move out",
  "OUTLINE_PASTE": "Paste",
  "OUTLINE_QUICK_INPUT": "Quick input",
  "OUTLINE_READONLY": "Outline is read only",
  "OUTLINE_SELECT_SUBTREE": "Select all subtree",
  "OUTLINE_TITLE": "New node",
  "OUTLINE_TOOLTIP_DROP_CHILD": "Become child",
  "OUTLINE_TOOLTIP_DROP_PARENT": "Move out",
  "OUTLINE_TOOLTIP_DROP_SIBLING": "Become sibling",
  "OUTLINE_UP": "Move up",
  "OUTLINE_WARNING_1": "Included",
  "OUTLINE_WARNING_2": " until January 2024!",
  "PAGE_BACK": "Page back",
  "PAGE_FIT": "Page Fit",
  "PAGE_WIDTH": "Page Width",
  "PASSWORD": "Password",
  "PASSWORD_RECOVERY": "PASSWORD RECOVERY",
  "PASSWORD_UPDATED": "Password successfully changed",
  "PASTE-AS-DEEP": "Paste text in brackets (...) as deep text",
  "PASTE-AS-MAP": "PASTE AS MAP",
  "PASTE-AS-NODE": "PASTE AS NODE",
  "PASTE-AS-TABLE": "PASTE AS TABLE",
  "PASTE-OPTIONS": "PASTE OPTIONS",
  "PASTE-OPTIONS-COLUMNS": "columns",
  "PASTE-OPTIONS-MANY-NODES": "many nodes",
  "PASTE-OPTIONS-MAP-DOWNUP": "tree from bottom",
  "PASTE-OPTIONS-MAP-LEFTRIGHT": "tree from left",
  "PASTE-OPTIONS-MAP-RADIAL": "radial",
  "PASTE-OPTIONS-MAP-RIGHTLEFT": "tree from right",
  "PASTE-OPTIONS-MAP-UPDOWN": "tree",
  "PASTE-OPTIONS-NODES-HORIZ": "nodes horizontally",
  "PASTE-OPTIONS-NODES-VERT": "nodes vertically",
  "PASTE-OPTIONS-ONE-COLUMN": "one column",
  "PASTE-OPTIONS-ONE-NODE": "single node",
  "PASTE-OPTIONS-ONE-ROW": "one row",
  "PASTE-OPTIONS-ROWS": "rows",
  "PASTE-OPTIONS-TAB": "single",
  "PASTE_HERE": "Open context-menu and paste here",
  "PASTE_IMAGE": "Paste",
  "PASTE_IN_NOTEPAD": "Paste in Notepad",
  "PASTE_MAP_IMAGE": "Paste map image",
  "PASTE_SELECTION": "Copy and paste",
  "PASTE_SELECTION_AS_DEEP": "Paste in deep",
  "PDF_DELETE": "Delete",
  "PDF_PLACEORDER": "Paste here PDF link",
  "PHYSICS_LABEL": "Physics",
  "PLAN_FULL": "Full",
  "PLAN_MAPS": "Maps only",
  "PLAY": "Play",
  "PLAY_SPEED": "Play speed",
  "PLEASE_WAIT": "Working, please wait...",
  "PLEASE_WAIT_LONG": "Working, please wait. This operation could take a while to complete",
  "POPUP_MANAGEMENT": "Popup management",
  "PREF_ASPECT_TITLE": "Aspect",
  "PREF_BACKGROUND_COLOR": "Background color",
  "PREF_BORDER_COLOR": "Border color",
  "PREF_COLOR": "Color",
  "PREF_DEEP": "Deep content",
  "PREF_DESC_FREE_EDGE": "The curvature of the free arrow can be changed manually",
  "PREF_DESC_MATH_KEYBOARDS": "Choose which math keyboards to enable when entering a math formula into a node.",
  "PREF_DESC_MATH_KEYBOARD_PREFS_1": "You can change this setting from",
  "PREF_DESC_MATH_KEYBOARD_PREFS_2": "File menu / Settings / Map / Mathematics",
  "PREF_DESC_MATH_KEYBOARD_TYPE_BASIC": "Keyboard suite for mathematical writings",
  "PREF_DESC_MATH_KEYBOARD_TYPE_PRIMARY": "Recommended keyboard for PRIMARY SCHOOL",
  "PREF_DESC_NODE_IMAGE": "Choose whether to have the frame of the image nodes. The frame of an image node can only be rectangular.",
  "PREF_EDGE": "Arrows",
  "PREF_EDGE_CURVE": "Curve",
  "PREF_EDGE_STRAIGHT": "Straight",
  "PREF_EDGE_TYPE": "Type",
  "PREF_EDGE_WIDTH": "Width",
  "PREF_EFFECTS": "Effects",
  "PREF_EFFECT_BOLD": "bold",
  "PREF_EFFECT_NONE": "none",
  "PREF_FONT": "Font",
  "PREF_MATH": "Mathematics",
  "PREF_MATH_KEYBOARDS": "Keyboards",
  "PREF_MATH_KEYBOARD_TYPE_BASIC": "Advanced",
  "PREF_MATH_KEYBOARD_TYPE_PRIMARY": "Base",
  "PREF_NODE_IMAGE": "Node image",
  "PREF_NODE_IMAGE_TITLE": "Node image",
  "PREF_NODE_TITLE": "Node",
  "PREF_NOTE": "Notes",
  "PREF_RESET": "Restore defaults",
  "PREF_RESET_MESSAGE": "Restore default values?",
  "PREF_SHAPE": "Shape",
  "PREF_SHAPE_ELLIPSE": "Ellipse",
  "PREF_SHAPE_RECT": "Rectangle",
  "PREF_SHAPE_ROUNDRECT": "Rounded",
  "PREF_SIZE": "Size font",
  "PREF_TEXT_TITLE": "Text",
  "PREF_TITLE_MATH_KEYBOARD": "Select math keyboards",
  "PREPARING_MAP": "Preparing map for Classroom...",
  "PREVIEW_NOT_AVAILABLE": "Preview not available",
  "PREVIOUS_PAGE_LABEL": "Previous page",
  "PREV_PAGE": "Previous page",
  "PRINT": "Print",
  "PRINT_PDF": "Print PDF",
  "PRIVACY_AGE_OVER_18": "I have more than 18 years",
  "PRIVACY_AGE_REQUEST": "Please select your age range",
  "PRIVACY_AGE_UNDER_18": "I have less than 18 years",
  "PRIVACY_CONFIRM": "Yes, confirm",
  "PRIVACY_CONTENT_GENERIC": "<h2><b>Privacy Policy</b></h2><div><p>I confirm that I have read the %privacypolicy% and I express my free consent to the processing of personal data, as specified in the aforementioned policy.</p></div>",
  "PRIVACY_CONTENT_PRIVATE_EDU_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-privati.pdf' target='_blank'>Privacy policy of SMX studio for privates</a>",
  "PRIVACY_CONTENT_PRIVATE_LAB_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-privati.pdf' target='_blank'>Privacy policy of SMX studio for privates</a>",
  "PRIVACY_CONTENT_SCHOOL_EDU_LINK": "<a href='https://privacy.smxstudio.it/mappe/smxstudio-mappe-privacy-scuole.pdf' target='_blank'>Privacy policy of SMX studio EDU for schools</a>",
  "PRIVACY_CONTENT_SCHOOL_LAB_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-scuole.pdf' target='_blank'>Privacy policy of SMX studio for schools</a>",
  "PRIVACY_CONTENT_UNIVERSITY_EDU_LINK": "<a href='https://privacy.smxstudio.it/mappe/smxstudio-mappe-privacy-universita.pdf' target='_blank'>Privacy policy of SMX studio for universities</a>",
  "PRIVACY_CONTENT_UNIVERSITY_LAB_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-universita.pdf' target='_blank'>Privacy policy of SMX studio for universities</a>",
  "PRIVACY_DOC_CONTRACT_GENERIC": "I declare that I have read and accepted the terms reported in the document %contract%.",
  "PRIVACY_DOC_CONTRACT_PRIVATE_EDU": "<a href='https://privacy.supermappex.it/edu/smx-edu-contratto-privati.pdf' target ='_blank'>IT services contract for access to the SMX studio for privates platform</a>",
  "PRIVACY_DOC_CONTRACT_PRIVATE_LAB": "<a href='https://privacy.supermappex.it/lab/smx-lab-contratto-privati.pdf' target ='_blank'>IT services contract for access to the SMX studio for privates platform</a>",
  "PRIVACY_DOC_CONTRACT_SCHOOL_EDU": "<a href='https://privacy.supermappex.it/edu/smx-edu-contratto-scuole.pdf' target ='_blank'>IT services contract for access to the SMX studio for schools platform</a>",
  "PRIVACY_DOC_CONTRACT_SCHOOL_LAB": "<a href='https://privacy.supermappex.it/lab/smx-lab-contratto-scuole.pdf' target ='_blank'>IT services contract for access to the SMX studio for schools platform</a>",
  "PRIVACY_DOC_CONTRACT_UNIVERSITY_EDU": "<a href='https://privacy.supermappex.it/edu/smx-edu-contratto-universita.pdf' target ='_blank'>IT services contract for access to the SMX studio for universities platform</a>",
  "PRIVACY_DOC_CONTRACT_UNIVERSITY_LAB": "<a href='https://privacy.supermappex.it/lab/smx-lab-contratto-universita.pdf' target ='_blank'>IT services contract for access to the SMX studio for universities platform</a>",
  "PRIVACY_DOC_DPA_EDU": "<a style='color: var(--mat-sys-tertiary)' href='https://privacy.supermappex.it/edu/smx-edu-dpa.pdf' target='_blank'>Data Processing Agreement SMX studio</a>",
  "PRIVACY_DOC_DPA_GENERIC": "I declare that I have read and accepted the terms set out in the document %dpa%.",
  "PRIVACY_DOC_DPA_LAB": "<a style='color: var(--mat-sys-tertiary)' href='https://privacy.supermappex.it/lab/smx-lab-dpa.pdf' target='_blank'>Data Processing Agreement SMX studio</a>",
  "PRIVACY_DOC_TITLE": "Contract and Terms of Service acceptance",
  "PRIVACY_ERROR": "Required",
  "PRIVACY_HEADER": "<h1><b>One more moment...</b></h1><div><p>We care about your privacy and use your data only if it is strictly necessary for SMX studio to work.</p></div><div><p>Before we go any further, we want to make sure that your rights and obligations regarding your data and content that you will insert into SMX studio are clear.</p></div><div><p>If SMX studio is used by a minor, the following declarations must be read and accepted by those who have parental responsibility.<br /> <p style='color: red'>* indicates required fields</p></p></div><br/>",
  "PRIVACY_NEWSLETTER_CONFIRM": "Yes, I'd like to subscribe to the newsletter",
  "PRIVACY_NEWSLETTER_INFO": "<a href='' target='_blank'></a>Sending the informative newsletter and any commercial information relating to Anastasis services and products, through specific online campaigns. The sending of these communications is reserved for users who declare that they have reached the age of 18.<br>For this purpose we ask you to give specific consent which can always be withdrawn by unsubscribing through the link in the communications received or by writing to the email address: <a href='mailto:privacy@anastasis.it' target='_blank'>privacy@anastasis.it</a><br><br>In the case of consent given by a minor, pursuant to art. 2 quinquies of Legislative Decree 196/2003 and 8 par 1 of EU Reg. 679/2016, please note that consent is validly expressed only if the same minor is over 14 years old.<br>Otherwise, consent must be given by the parent or tutor.<br><br>For sending such communications, we use Mailchimp, a platform that uses the GDPR standards for data protection.<br>For more information: <a href='https://mailchimp.com/legal/privacy' target='_blank'>mailchimp.com/legal/privacy</a>",
  "PRIVACY_PURPOSE": "Purpose of the processing",
  "PRIVACY_PURPOSE_A": "a) creation of an account for access to the platform and use of the SMX studio %planId% service for the creation and sharing of multimedia concept maps, in the context of inclusive and collaborative teaching (as provided for in art. 6 letter b GDPR).",
  "PRIVACY_PURPOSE_B": "b) the fulfillment of the legal obligations established by the legal regulations for the requirements established by the fiscal and tax legislation. The legal basis of the processing is the fulfillment of a legal obligation (as provided for in art. 6 letter c) GDPR).",
  "PRIVACY_PURPOSE_C": "c) to allow navigation, registration and access, the legitimate interest of the Data Controller in making navigation usable and safe (art. 6, par. 1 letter f of EU Regulation 2016/679) and to ascertain, exercise or defense of a right in court and out of court (legitimate interest) of the undersigned organizations (art. 6, par. 1 letter f) EU Regulation 2016/679).",
  "PUBLIC_SHARE_EDIT_PERMISSION_DESCRIPTION": "All the users with the link can edit the document",
  "PUBLIC_SHARE_LIMIT_ANYONE_WITH_LINK": "Anyone with the link",
  "PUBLIC_SHARE_LIMIT_ONLY_PERMISSION": "With limitations",
  "PUBLIC_SHARE_LIMIT_ONLY_PERMISSION_DESCRIPTION": "Only the users with access can open the document",
  "PUBLIC_SHARE_VIEW_ONLY_PERMISSION_DESCRIPTION": "All the users with the link can view the document",
  "QRCODE_TITLE_DOC": "Scan to open the document",
  "QRCODE_TITLE_GDOC": "Scan to open Google Document",
  "QUICKEDIT_TOOLBAR_MSG": "Quick edit enabled",
  "RACU_LINK": "https://www.anastasis.it/contatti/",
  "RACU_LINK_TEXT": "Customer Service",
  "RACU_TEXT_01": "This kind of subscription cannot be renewed with automated process.",
  "RACU_TEXT_02": "Please renew your afterschool agreement",
  "RACU_TEXT_03": "or contact our",
  "RACU_TITLE": "Afterschool subscription renewal",
  "RANGE_PAGE_LABEL_1": "0 of {{length}}",
  "RANGE_PAGE_LABEL_2": "{{page}} of {{length}}",
  "RCU_LINK": "https://www.anastasis.it/contatti/",
  "RCU_LINK_TEXT": "Customer Service",
  "RCU_TEXT_01": "This kind of subscription cannot be renewed with automated process.",
  "RCU_TEXT_02": "To renew, please contact our",
  "RCU_TEXT_03": "To renew, please contact your administrator",
  "RCU_TITLE": "Subscription renewal",
  "READONLY_MAP": "Read only map",
  "READ_ONLY": "read only",
  "READ_TITLE": "Read",
  "RECENT_COPY_PLUR": "copies",
  "RECENT_COPY_SING": "copy",
  "RECENT_MAPS": "All maps",
  "RECENT_MENU_CREATECOPY": "Create copy",
  "RECENT_MENU_DOWNLOAD": "Download",
  "RECENT_MENU_REMOVE": "Remove from recents",
  "RECENT_MENU_RENAME": "Rename",
  "RECENT_TOOLBAR_SHOW-LIST": "show list",
  "RECENT_TOOLBAR_SHOW-PREVIEWS": "show previews",
  "RECENT_TOOLBAR_SORT": "Order by",
  "RECENT_TOOLBAR_SORT-ALPHABETIC": "alphabetic",
  "RECENT_TOOLBAR_SORT-DATE": "by date",
  "RECENT_VIEW_PLUR": "views",
  "RECENT_VIEW_SING": "view",
  "RECVIDEO_BUTTON": "Record video",
  "REENTEREMAIL": "Please provide your email for confirmation",
  "REFORDERID_NEW": " (new)",
  "REFORDERID_RENEW": " (renewed)",
  "REFORDERID_UPDATE": " (modified)",
  "REGISTER_MSG": "We will check if you already have an account. If not, we will help you create one and activate a 30-day trial period, during which you will have access to all the features of SMX studio",
  "RELOAD_PAGE": "Reload page",
  "REMIND_ME_TOMORROW": "Remember me tomorrow",
  "REMOVE_AVATAR": "Remove photo",
  "REMOVE_RECENT_MAP": "Remove from list",
  "REMOVE_SIDE_BY_SIDE": "Remove side by side",
  "RENAME_RECENT_MAP": "Rename",
  "REPORT": "WORKGROUPS",
  "REPORT_ACTIVESTUDENTS": "YOUR ACTIVE STUDENTS THIS MONTH",
  "REPORT_ADMIN_TITLE": "Admin stats",
  "REPORT_AGO": "Aug",
  "REPORT_APR": "Apr",
  "REPORT_CLASSROOM": "on Google Classroom",
  "REPORT_CLASSROOM_TITLE": "Classroom stats",
  "REPORT_COPIES": "Copies",
  "REPORT_CREATEDMAPS1": "You created",
  "REPORT_CREATEDMAPS2": "maps created",
  "REPORT_DETAIL": "Detail",
  "REPORT_DIC": "Dec",
  "REPORT_DONE": "What you did with your maps",
  "REPORT_EXPORT": "From map",
  "REPORT_FACEBOOK": "on Facebook",
  "REPORT_FEB": "Feb",
  "REPORT_GEN": "Jan",
  "REPORT_GIU": "Jun",
  "REPORT_GOOGLEDOCS1": "You created",
  "REPORT_GOOGLEDOCS2": "Google documents",
  "REPORT_GOTOREPORT": "go to Report",
  "REPORT_IMAGES": "Images",
  "REPORT_INSERT": "MAPS",
  "REPORT_LINK": "as link",
  "REPORT_LINKS": "Links",
  "REPORT_LINK_QRCODE": "link/QRcode",
  "REPORT_LUG": "Jul",
  "REPORT_MAG": "May",
  "REPORT_MAR": "Mar",
  "REPORT_NEWMAPS": "New",
  "REPORT_NODES": "Nodes",
  "REPORT_NOV": "Nov",
  "REPORT_OPENMAPS": "Opened",
  "REPORT_OTT": "Oct",
  "REPORT_PRINTS2": "Prints",
  "REPORT_SET": "Sep",
  "REPORT_SHARES": "Shares",
  "REPORT_SHARING": "Shared maps",
  "REPORT_SHOW2": "Presentations",
  "REPORT_SOCIALS": "Where you shared your maps",
  "REPORT_STATORDER1": "your",
  "REPORT_STATORDER2": "students created",
  "REPORT_STATORDER3": "maps and opened ",
  "REPORT_STATS": "Stats",
  "REPORT_STUDENTS": "Students",
  "REPORT_STUDENTWORKS": "YOUR STUDENT WORKS",
  "REPORT_TABLES": "Tabes",
  "REPORT_USER_TITLE": "User stats",
  "REPORT_VIDEOS": "Videos",
  "REPORT_VIEWS": "Views",
  "REPORT_WORDS": "Words",
  "REQUEST_RECOVERY_PASSWORD": "Request password recovery",
  "REQUEST_SAVE_CHANGES": "Save the document '{%s}' before closing it?",
  "REQUEST_SIGNIN": "First Access",
  "RESET_PASSWORD": "Reset password",
  "RESPONSE_RP_1": "We just sent you an email at ",
  "RESPONSE_RP_2": "%email% containing a link to set a new password.",
  "RESPONSE_RP_3": "You should receive this email within a few seconds. If not, please check your Spam/Junk emails.",
  "RESPONSE_RP_4": "If necessary you can also contact ",
  "RESPONSE_RS_1": "We just sent you an email at ",
  "RESPONSE_RS_2": "%email% containing a link to access to SMX studio the first time.",
  "RESPONSE_RS_3": "You should receive this email within a few seconds. If not, please check your Spam/Junk emails.",
  "RESPONSE_RS_4": "If necessary you can also contact ",
  "RESTORE": "Restore",
  "RESTORE_MESSAGE": "Map is trashed! Would you like restore it?",
  "RESTORE_TITLE": "Restore document",
  "RICONNNECT_GOOGLE_ACCOUNT": "Warning. Try to reconnect your Google Account!",
  "ROLE_ADMIN": "Administrator",
  "ROLE_AID": "AID operator",
  "ROLE_ANASTASIS": "Anastasis operator",
  "ROLE_USER": "User",
  "ROTATE_LEFT": "Rotate left",
  "ROTATE_RIGHT": "Rotate right",
  "SAVE": "Save",
  "SAVE_IMAGE": "Save",
  "SAVE_TOOLTIP": "The changes are automatically saved in the drive",
  "SAVING": "Saving in progress...",
  "WAITING_CLAIRE": "Waiting for Claire...",
  "SAVING_OTHER": "Now saving",
  "SCHOOL_YEAR": "School year",
  "SEARCH": "Search",
  "SEARCH_CLEAR": "Clear search",
  "SEARCH_CLOSE": "Close",
  "SEARCH_DOCS": "Search document",
  "SEARCH_GOOGLE": "Search in Google",
  "SEARCH_GOOGLEIMG": "Search in Google image",
  "SEARCH_IMAGES": "Search images",
  "SEARCH_IN": "Search in",
  "SEARCH_IN_GOOGLE_IMAGE": "Search in Google images",
  "SEARCH_IN_MAP_PLACEHOLDER": "Search in document",
  "SEARCH_IN_WIKIPEDIA": "Search in Wikipedia",
  "SEARCH_IN_YOUTUBE": "Search on Youtube",
  "SEARCH_MAGIC": "Magic search",
  "SEARCH_MAP_PLACEHOLDER": "Search document...",
  "SEARCH_ON_WEB": "Search on web",
  "SEARCH_PLACEHOLDER": "Search...",
  "SEARCH_SELECTION": "Search in document",
  "SEARCH_WIKIPEDIA": "Search in Wikipedia",
  "SEARCH_YOUTUBE": "Search on Youtube",
  "SELECT_FOLDER": "Select a folder",
  "SEND": "Send",
  "SEND_MAIL": "Send email",
  "SEND_TO_EDITOR": "Edit",
  "SETS_LABEL": "Sets",
  "SET_PASS1": "The new password must meet these criteria:",
  "SET_PASS2": "at least 12 characters",
  "SET_PASS3": "at least 1 letter",
  "SET_PASS4": "at least one number and special character",
  "SET_PASS5": "Be careful not to include references to your email or your name and surname in your password, which are easily identifiable.",
  "SHAREDOC_ADD_USER": "Email to authorize",
  "SHAREDOC_OWNER": "Owner",
  "SHAREDOC_PUBLIC": "Public access",
  "SHAREDOC_TITLE": "Document sharing",
  "SHAREDOC_USERSLIST": "People to share",
  "SHAREDOC_USER_ADD": "%username% shared with you the document \n<b>%docname%</b>",
  "SHAREDOC_USER_DELETE": "%username% removed sharing for document \n<b>%docname%</b>",
  "SHAREDOC_USER_OPEN_DOC": "%username% opened the document \n<b>%docname%</b>",
  "SHAREDOC_WARNING_NOT_SHARED": "WARNING!\nThis document is currently shared with no one.\nIf you want to share it with someone remember to assign sharing rights.",
  "SHARED_EDIT": "Collaborative share",
  "SHARED_EDIT_MINE": "Shared document",
  "SHARED_EDIT_OTHER_AUTHOR": "Document by",
  "SHARED_PUBLIC": "Publicly shared",
  "SHARED_VIEW": "Readonly share",
  "SHARED_VIEW_MINE": "Shared document",
  "SHARED_VIEW_OTHER_AUTHOR": "Document by",
  "SHAREGROUP_FREQ": "Frequently used",
  "SHAREGROUP_GROUP": "Your workgroup",
  "SHARE_COPY_LINK": "Copy link",
  "SHARE_DETAILS": "Sharing details",
  "SHARE_DETAILS_COPIES": "{1} copies from day {2}",
  "SHARE_DETAILS_PEOPLE": "Shared with {1} people",
  "SHARE_DETAILS_VIEWS": "{1} views from day {2}",
  "SHARE_LINK_COPY": "Copy in clipboard",
  "SHARE_LINK_EDIT": "Edit",
  "SHARE_LINK_LINK": "LINK",
  "SHARE_LINK_NONE": "With limitations",
  "SHARE_LINK_QRCODE": "QRcode",
  "SHARE_LINK_READONLY": "View only",
  "SHARE_LINK_REMOVE": "Remove access",
  "SHARE_LINK_SHARE_TYPE": "Public sharing settings",
  "SHARE_NONAME": "You",
  "SHARE_RECENT": "Share",
  "SHARE_SAVE_MESSAGE": "Share settings updated",
  "SHARING_MESSAGE_CANDO": "You can copy the link and view the QRcode",
  "SHARING_MESSAGE_EDIT": "If you share the map, anyone with the link can view",
  "SHARING_MESSAGE_VIEW": "The map is in VIEW only, you cannot share",
  "SHARING_STOPPED": "Public sharing stopped",
  "SHOWING": "Presentation mode",
  "SHOW_DISABLED": "Showing only if map saved",
  "SHOW_STATS": "Show stats",
  "SHOW_TOOLBAR_NEXT": "Next step",
  "SHOW_TOOLBAR_PREV": "Previous step",
  "SIDEBAR_PDF": "Toggle sidebar",
  "SIGNIN": "Sign in",
  "SIZE_TOOLBAR-BOTH": "Both",
  "SIZE_TOOLBAR-HEIGHT": "Height",
  "SIZE_TOOLBAR-SIZE": "Resize",
  "SIZE_TOOLBAR-WIDTH": "Width",
  "SPEAKER_DEFAULT": "Default speaker",
  "SPEAKER_TOOLBAR": "Speaker voice",
  "SPEECHEDIT_TOOLBAR_MSG": "Speech edit enabled",
  "START_DATE": "Starting date",
  "STATS_ANNUAL_CHART_TITLE": "Annual trend by activity",
  "STATS_CREATED_FILES_LABEL": "Created files",
  "STATS_CURRENT_MONTH": "Current month",
  "STATS_CURRENT_YEAR": "Current year",
  "STATS_EDITOR_TOTAL": "Editors",
  "STATS_EXPORT": "Download Statistics",
  "STATS_FORMULAS_TOTAL": "Math",
  "STATS_LABEL_EDITOR": "Editor",
  "STATS_LABEL_EDITOR_CREATE": "Created",
  "STATS_LABEL_EDITOR_IMPORT": "Imported",
  "STATS_LABEL_EDITOR_OPEN": "Opened",
  "STATS_LABEL_EDITOR_SHARED_COPY": "Copy shared",
  "STATS_LABEL_EDITOR_SHARED_VIEW": "Show shared",
  "STATS_LABEL_MAPS": "Maps",
  "STATS_LABEL_MAP_CREATE": "Created",
  "STATS_LABEL_MAP_IMPORT": "Imported",
  "STATS_LABEL_MAP_OPEN": "Opened",
  "STATS_LABEL_MAP_SHARED_COPY": "Copy shared",
  "STATS_LABEL_MAP_SHARED_VIEW": "Show shared",
  "STATS_LABEL_MAP_SHOW": "Presented",
  "STATS_LABEL_MATH": "Math",
  "STATS_LABEL_MATH_AI_CHECK": "AI check",
  "STATS_LABEL_MATH_INSERT_IN_DOCUMENT": "Inserted in doc",
  "STATS_LABEL_MATH_OCR": "OCR",
  "STATS_LABEL_MATH_OCR_IN_EDITOR": "OCR in editor",
  "STATS_LABEL_MULTIMEDIA": "Multimedia",
  "STATS_LABEL_MULTIMEDIA_IMAGE": "Images",
  "STATS_LABEL_MULTIMEDIA_LINK": "Link",
  "STATS_LABEL_MULTIMEDIA_VIDEO": "Video",
  "STATS_LABEL_PDF": "PDF",
  "STATS_LABEL_PDF_IMPORT": "Imported",
  "STATS_LABEL_PDF_OPEN": "Opened",
  "STATS_LABEL_PDF_SHARED_COPY": "Copy shred",
  "STATS_LABEL_PDF_SHARED_VIEW": "Show shared",
  "STATS_LABEL_PRINT": "Prints",
  "STATS_LABEL_PRINT_EDITOR": "Documents",
  "STATS_LABEL_PRINT_MAP": "Maps",
  "STATS_LABEL_PRINT_PDF": "PDF",
  "STATS_LABEL_SHARES": "My sharings",
  "STATS_LABEL_SHARING_EDITOR_CLASSROOM": "Documents Classroom",
  "STATS_LABEL_SHARING_EDITOR_INTERNAL": "Documents internal",
  "STATS_LABEL_SHARING_MAP_CLASSROOM": "Maps Classroom",
  "STATS_LABEL_SHARING_MAP_INTERNAL": "Maps internal",
  "STATS_LABEL_SHARING_PDF_CLASSROOM": "PDF Classroom",
  "STATS_LABEL_SHARING_PDF_INTERNAL": "PDF internal",
  "STATS_MAPS_TOTAL": "Maps",
  "STATS_OPENED_FILES_LABEL": "Opened files",
  "STATS_PDF_TOTAL": "PDFs",
  "STATS_PREVIOUS_YEARS": "Previous years",
  "STATS_PRINTED_TOTAL": "Printed files",
  "STATS_SCHOOL_YEAR": "School year",
  "STATS_SEARCH_PLACEHOLDER": "eg. John Smith",
  "STATS_SECTION_1": "Section 1 - General activities",
  "STATS_SECTION_2": "Section 2 - Specific activities",
  "STATS_SECTION_3": "Section 3 - Environments usage",
  "STATS_SECTION_4": "Section 4 - Activities details",
  "STATS_SECTION_4_BASE": "Activities details",
  "STATS_SECTION_USERS": " Section 5 - Users who access SMX studio",
  "STATS_SECTION_USERS_NO_USERS": "No configured users",
  "STATS_TOOLTIP_HEADER4": "",
  "STATS_TOOLTIP_HEADER4_EVENTS": "Events",
  "STATS_TOOLTIP_HEADER4_MODULES": "Module",
  "STATS_TOOLTIP_SHARED": "Sum of openings and copies of shared files from other users",
  "STATS_TOTAL_CREATED": "Created files",
  "STATS_TOTAL_INTERACTIONS": "Interactions",
  "STATS_TOTAL_OPENED": "Opened files",
  "STATS_TOTAL_SHARED": "Files shared",
  "STATS_USERS_EMAIL": "Email",
  "STATS_USERS_FILTER": "Filter",
  "STATS_USERS_FULLNAME": "Full name",
  "STATS_USERS_LABEL": "Users",
  "STATS_USERS_NO_DATA_FOUND": "No user found for the filter",
  "STATS_USERS_OPEN_STATS": "Open user stats",
  "STATS_USERS_STATS": "User stats",
  "STAT_ADDIMAGE": "Images",
  "STAT_ADDLINK": "Link",
  "STAT_ADDNODE": "Nodes",
  "STAT_ADDTABLE": "Tables",
  "STAT_ADDVIDEO": "Videos",
  "STAT_COPYSHARED": "Copies",
  "STAT_NEWMAP": "Maps",
  "STAT_OPENMAP": "Opened",
  "STAT_SHARELINK": "Shared maps",
  "STAT_VIEWSHARED": "Views",
  "STAT_WORDS": "Words",
  "STOP": "Stop",
  "STOP_ANYWAY": "Stop anyway",
  "STOP_SHARING_MAP": "Stop public sharing",
  "STORAGE_QUOTA_EXCEEDED": "The user's Drive storage quota has been exceeded.",
  "SUBSCRIPTION": "Subscription",
  "SUBSCRIPTIONS_LIST": "Subscriptions",
  "SUBSCRIPTION_NOTES": "Operator notes",
  "SUSPEND_SUBSCRIPTION": "Deactivate subscription",
  "SWAP": "Swap panels",
  "TABLE_MAXCOLROW": "Number must be a value between 2 and 10",
  "TABLE_REQUIRED": "Field is required",
  "TABLE_TOOLBAR-ADD-COL-AFTER": "Add column after",
  "TABLE_TOOLBAR-ADD-COL-BEFORE": "Add column before",
  "TABLE_TOOLBAR-ADD-ROW-ABOVE": "Add row above",
  "TABLE_TOOLBAR-ADD-ROW-BELOW": "Add row below",
  "TABLE_TOOLBAR-LOCK": "Lock table",
  "TABLE_TOOLBAR-REMOVE-COL": "Delete column",
  "TABLE_TOOLBAR-REMOVE-ROW": "Delete row",
  "TABLE_TOOLBAR-REMOVE-TABLE": "Remove table",
  "TABLE_TOOLBAR-UNLOCK": "Unlock table",
  "TABLE_WARNING_EXTENDED": "Table contains {%r} rows and {%c} columns. Confirm paste?",
  "TABLE_WARNING_TOOBIG": "Table contains {%r} rows and {%c} columns and it's too big ti be pasted. Do you want to paste its content in a single node?",
  "TAGGED_DOCUMENT": "Tagged document ",
  "TAGS": "Tag",
  "TAGS_DIALOG_ADD_TAG_BUTTON_TEXT": "Add tag",
  "TAGS_DIALOG_ASSOCIATED_SUBTITLE": "Assigned tags (you can assign up to 4 tags)",
  "TAGS_DIALOG_ASSOCIATED_TAGS_LIMIT_REACHED_MESSAGE": "Limit of 4 tags reached",
  "TAGS_DIALOG_AVAILABLE_SUBTITLE": "Available tags",
  "TAGS_DIALOG_CREATE_AND_ASSOCIATE_TAG_ERROR_MESSAGE": " Tag already exists",
  "TAGS_DIALOG_SEARCH_LABEL": "Search tags",
  "TAGS_DIALOG_TITLE": "Tag",
  "TAGS_MERGE": "Oops! The tag '%tag_name%' has already been created. Do you want to merge them and update the documents, or would you prefer to use a different name?",
  "TAGS_USAGE_COUNT": "file",
  "TAG_CONFIRM_MERGE": "Merge and update",
  "TAG_DELETED": "Tag '%s' deleted",
  "TAG_MANAGER": "Tag Manager",
  "TAG_NAME": "Tag name",
  "TAG_RENAME": "Rename tag",
  "TEAM_DRIVE_FILE_LIMIT_EXCEEDED": "The file limit for this shared drive has been exceeded.",
  "TEAM_DRIVE_MEMBERSHIP_REQUIRED": "The attempted action requires shared drive membership.",
  "TEST": "TEST",
  "TEXT_NO_MAPS": "Create new ones or open existing ones",
  "THEME_AUTO": "Auto",
  "THEME_DARK": "Dark",
  "THEME_LIGHT": "Light",
  "TITLE_BLOCKNOTES": "Untitled notes",
  "TITLE_COPY_MAP": "Copy map",
  "TITLE_OPEN_MAP": "Open map",
  "TITLE_RENAME_DOC": "Rename",
  "TOAST_CANCEL": "Cancel",
  "TOAST_CLOSE": "Close",
  "TOAST_LINK_COPIED": "Link pasted in clipboard",
  "TOAST_OPEN": "Open",
  "TOAST_TAG_REMOVED_MESSAGE": "Tag #TAG# removed from file",
  "TOAST_TAG_REMOVE_ERROR_MESSAGE": "Error removing tag #TAG# from file",
  "TODO": "To Do:",
  "TODOLIST_ADD_ABOVE": "Add activity",
  "TODOLIST_ADD_BELOW": "Add detail",
  "TODOLIST_DELETE": "Delete node and children",
  "TODOLIST_DELETEALL": "Delete all",
  "TODOLIST_DELETEALL_MESSAGE": "Confirm deleting all tasks?",
  "TODOLIST_DOWN": "Move down",
  "TODOLIST_EDIT": "Edit text",
  "TODOLIST_IN": "Move in",
  "TODOLIST_INSERTTEXT": "Write here what you need to do",
  "TODOLIST_OUT": "Move out",
  "TODOLIST_PASTE": "Paste all",
  "TODOLIST_PIN": "Highlight",
  "TODOLIST_UNPIN": "Unhighlight",
  "TODOLIST_UP": "Move up",
  "TRASH_BIN": "Trash",
  "TRASH_DELETE_CONFIRM": "If you confirm, the map will be deleted permanently.",
  "TRASH_EMPTIED": "The trash bin has been emptied",
  "TRASH_EMPTY": "Empty recycle bin",
  "TRASH_EMPTY_CONFIRM": "Are you sure you want to empty recycle bin?\nYou will not be able to restore deleted maps.",
  "TRASH_RECENT_MAP": "Move to trash",
  "TRASH_REMOVE_CONFIRM": "If you confirm, the document will be removed from your list and to open it you will need the link from the author.",
  "TRASH_RESTORE_OPEN_CONFIRM": "Do you want to restore the map and open it?",
  "TRASH_WARNING": "Any files you delete will be moved here.",
  "TRASH_WARNING2": "You have 30 days to restore them,",
  "TRASH_WARNING3": "after which they will be automatically deleted from the trash.",
  "TRIGONOMETRY_LABEL": "Trigonometry",
  "TTS_ENABLED_SPEECHSYNTHESIS_MESSAGE": "Text to speech enabled",
  "TTS_SPEECHSYNTHESIS_ENABLE_REQUEST": "Do you want to enable Text-to-speech?",
  "UNKNOWN_USERNAME": "Unknown user",
  "UNLOCK_DOC": "Unlock document",
  "UNSAVED_CHANGES": "You have unsaved changes. Are you sure you want to exit?",
  "UNTRASH_RECENT_MAP": "Restore",
  "UPDATE": "Update",
  "UPDATE_GOOGLE_DOC": "Update Google Doc",
  "USERDESKTOP_TITLE": "User's Configuration",
  "USERNAME": "Email",
  "USERS_DELETE": "Delete user",
  "USERS_LIST": "Users list",
  "USERS_LIST_INCOMPLETE": "Users list incomplete",
  "USERS_MANAGEMENT": "Users management",
  "USER_DELETED": "User deleted:",
  "USER_DELETE_FAIL": "Whoops! Something went wrong, user not deleted:",
  "USER_DELETE_SHORT": "Type at least 3 chars to search for users",
  "USER_EXPIRED": "Subscription is expired",
  "USER_IS_ME": " (you)",
  "USER_IS_NOT_OWNER": "This map has been made by someone else",
  "USER_IS_OWNER": "You are the author of the map",
  "USER_PROFILE_TITLE": "User profile",
  "USER_RATE_LIMIT_EXCEEDED": "User Rate Limit Exceeded.",
  "USER_STATS": "SMX studio - user statistics",
  "USER_STATS_VISIBILITY": "Visible only to you, as a user",
  "USER_STATS_WHO": "Contents overview for user",
  "VERSION": "Version",
  "VIEW_FIND_PDF": "Find in document",
  "VIEW_MODE": "View",
  "VOICES": "Voices",
  "WAIT": "Wait",
  "WAIT_A_MOMENT": "Wait a moment...",
  "WARNING": "Warning",
  "WARNING_STOP_SHARING": "Removing the map from the recents, the sharing will be stopped.",
  "WEBINAR": "Webinar",
  "WIKIPEDIA": "Wikipedia",
  "WITHOUT_FRAME": "without frame",
  "WITH_FRAME": "with frame",
  "WORKSPACE_ADDITIONAL_TOOLS_DESC": "Configure the tools that you would like to have in the Additional Tools  Extra.",
  "WORKSPACE_ADDITIONAL_TOOLS_TITLE": "Additional tools",
  "WORKSPACE_ADD_LINK": "Add custom link",
  "WORKSPACE_ALL_LABEL": "All",
  "WORKSPACE_APPLY_BTN": "Save configuration",
  "WORKSPACE_BUSY": "Wait, document is busy.",
  "WORKSPACE_CONFIGURATION_TITLE": "Configuration",
  "WORKSPACE_CREATE_BTN": "Create",
  "WORKSPACE_DATABASE_TITLE": "Database",
  "WORKSPACE_DOCS_TITLE": "Documents",
  "WORKSPACE_EXTRA_APPLIED": "Settings applied",
  "WORKSPACE_EXTRA_DESC": "Configure the Extras that you would like to have in the toolbar.",
  "WORKSPACE_FILENAME_LABEL": "Name",
  "WORKSPACE_IMAGEEDITOR_DROP": "Drop image",
  "WORKSPACE_IMAGEEDITOR_IMPORT": "Import image",
  "WORKSPACE_IMAGEEDITOR_PASTE": "Paste image",
  "WORKSPACE_IMAGEEDITOR_TITLE": "Paste image",
  "WORKSPACE_IMAGE_EDITOR_TITLE": "Image editor",
  "WORKSPACE_LASTOPENED_LABEL": "Last opened",
  "WORKSPACE_LINKS_DESC": "Add links to your favorite websites to have them always available. For instance, you can add the links to your favorite AI tools.",
  "WORKSPACE_LINKS_TITLE": "Links",
  "WORKSPACE_LINK_CANCEL": "Cancel",
  "WORKSPACE_LINK_CONFIRM": "Confirm",
  "WORKSPACE_LINK_NAME_LABEL": "Link name",
  "WORKSPACE_LINK_URL_LABEL": "Link URL",
  "WORKSPACE_MAPS_TITLE": "Maps",
  "WORKSPACE_MATH_CONFIG_DESC": "Here you can configure which keyboard should be enabled when entering a math formula or expression.",
  "WORKSPACE_MATH_CONFIG_TITLE": "Math keyboard",
  "WORKSPACE_NO_DOCS": "No Documents found",
  "WORKSPACE_NO_MAPS": "No Maps found",
  "WORKSPACE_NO_PDFS": "No PDF found",
  "WORKSPACE_OPEN_FILE_TITLE": "Open file",
  "WORKSPACE_PDFS_TITLE": "PDFs",
  "WORKSPACE_PROMPT_GENERATOR_TITLE": "Prompt generator",
  "WORKSPACE_RECENT_LABEL": "Recent",
  "WORKSPACE_TODO_LIST_TITLE": "To-do list",
  "WORKSPACE_NO_TAGS_SELECTED": "Select at least one tag to display the documents associated",
  "WORKSPACE_NO_FILE_WITH_TAGS_SELECTED": "No files found for these tags",
  "WRONG_PARAMS": "Some mandatory param is missing",
  "YOUR_EMAIL": "Sign in with your email",
  "YOUTUBE": "Youtube",
  "access_denied": "Access denied",
  "auth/too-many-requests": "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
  "auth/wrong-password": "Wrong Password",
  "SCHOOL_EMAIL": "Do you have a Google school account?",
  "SCHOOL_EMAIL_MESSAGE": "Sign in with Google to avoid authentication issues.",
  "RESPONSE_RS_5": "If your school uses Google, and you didn't receive the email, ",
  "RESPONSE_RS_6": "go back to login ",
  "RESPONSE_RS_7": "and Sign in with Google.",
  "HELP_MENU": {
    "BUTTON_TOOLTIP": "Help",
    "GUIDE": "Read the online GUIDE",
    "VIDEO": " Watch the VIDEO tutorial",
    "FAQ": "FAQ",
    "FEEDBACK": "Help us to improve",
    "SUPPORT": "Ask support"
  },
  "NO_MATH_DIALOG": {
    "TITLE": "Math Keyboard",
    "MESSAGE": "The full version of SMXstudio is required to use the math keyboard and its calculation features. To obtain it, please contact <a href=\"https: //www.anastasis.it/en/\">Customer Service</a>:",
    "MESSAGE_NO_COMMERCIAL": "To use the math keyboard and access the mathematical calculation features, you need SMX studio - a complete solution with Editor and PDF modules too!",
    "TIME_TABLE_1": "Monday to Friday",
    "TIME_TABLE_2": "from 8:30 to 13:00 and from 14:30 to 18:00",
    "TIME_TABLE_3": "call 051 29 62 121"
  },
  "ADVANCED_FUNCTION_DIALOG": {
    "TITLE": " Advanced Function",
    "MESSAGE": "This is an advanced function and to use it you must have the full version of SMX studio. For more information, contact customer service.",
    "TIME_TABLE_1": "Monday to Friday",
    "TIME_TABLE_2": "from 8:30 to 13:00 and from 14:30 to 18:00",
    "TIME_TABLE_3": "call 051 29 62 121"
  },
  "LANGUAGE_SUPPORT_NOTIFICATION_TOOLTIP": "Spellchecker is disabled. Reload the page",
  "LANGUAGE_SUPPORT_SPELLCHECKER_TOAST_MESSAGE": "Do you want to update the spellchecker?",
  "LANGUAGE_SUPPORT_SPELLCHECKER_TOAST_ACTION": "Reload",
  "LANGUAGE_SUPPORT_SPELLCHECKER_NOT_SUPPORTED_TOAST_MESSAGE": "Spellchecker is disabled: language not supported",
  "BUY_CREDITS_TITLE": "Buy AI Credits",
  "BUY_CREDITS_AVAILABLE": "User balance:",
  "BUY_CREDITS_CREDITS": "Credits",
  "BUY_CREDITS_PRICE": "Price",
  "BUY_CREDITS_BUY": "Add to cart",
  "BUY_CREDITS": "Buy Credits",
  "BUY_CREDITS_PER_CREDIT": "credit",
  "BUY_CREDITS_INFO": "Credits will be immediately added to your balance after the payment",
  "ERROR_LOADING_USER_CREDITS": "Error reading user credits",
  "ERROR_SUBSCRIPTION_ID": "Could not find a single user subscription id",
  "CREDITS_LISTING_TITLE": "Price list",
  "AI_TARIFFS_FUNCTIONTYPE": "Function",
  "AI_TARIFFS_CREDITCOST": "Credit usage",
  "AI_DICTIONARY": "Vocabulary",
  "AI_SIMPLIFY": "Simplify",
  "AI_OUTLINE": "Maps outline",
  "AI_SUMMARY": "Summary",
  "AI_TIMELINE": "Timeline",
  "AI_CAUSE_EFFECT": "Cause-Effect",
  "AI_WHO_WHAT_WHERE_WHEN": "Who-What-Where-When",
  "AI_BEFORE_READ": "Before reading",
  "AI_BASIS": "Basics",
  "AI_EXERCISES": "Exercises",
  "AI_QUESTIONS": "Questions",
  "AI_SELECT_FUNCTIONS": "Choose the functions you want to activate in Claire",
  "AREA_NAME": {
    "LANGUAGE": "Language Area",
    "MENTAL_SCHEME": "Mental Scheme Area",
    "PRIOR_KNOWLEDGE": "Prior Knowledge Area",
    "VERIFY_KNOWLEDGE": "Verify Knowledge Area"
  },
  "AREA_DESCRIPTION": {
    "LANGUAGE": "Area linguistica",
    "MENTAL_SCHEME": "Area schemi mentali",
    "PRIOR_KNOWLEDGE": "Area conoscenze pregresse",
    "VERIFY_KNOWLEDGE": "Area verifica conoscenze"
  },
  "AI_FUNCTION": {
    "DICTIONARY": "Dictionary",
    "SIMPLIFY": "Simplify",
    "OUTLINE": "Maps outline",
    "SUMMARY": "Summary",
    "TIMELINE": "Timeline",
    "CAUSE_EFFECT": "Cause-Effect",
    "WHO_WHAT_WHERE_WHEN": "Who-What-Where-When",
    "BEFORE_READ": "Before reading",
    "BASIS": "Basics",
    "EXERCISES": "Exercises",
    "QUESTIONS": "Questions",
    "TUTOR_QUIZ": "Tutor-Quiz"
  },
  "AI_FUNCTION_DESCRIPTION": {
    "DICTIONARY": " Text Glossary - Difficult words",
    "SIMPLIFY": " Simplification - Short sentences",
    "OUTLINE": "Hierarchical bullet list",
    "SUMMARY": "Sequences - Summary",
    "TIMELINE": "Timeline",
    "CAUSE_EFFECT": "Cause and Effect",
    "WHO_WHAT_WHERE_WHEN": "Who? What? Where? When?",
    "BEFORE_READ": "Before reading analysis",
    "BASIS": "Pre-requisites analysis",
    "EXERCISES": "Exercises",
    "QUESTIONS": "Post-reading consolidation",
    "TUTOR_QUIZ": "Tutor - Quiz"
  },
  "NEW_BADGE": "New",
  "CLAIRE_NEW_MENU_TEXT": "I'm <b>Claire</b>: The artificial intelligence that helps you understand, not copy.<br>I'm already in your <b>workspace</b>:<br>Open a document, yours or a new one, and let's start working together right away!",
  "CLAIRE_DISABLED_TEXT": "To use Claire you need to <b>renew your SMX studio subscription</b>.<br/>Any <b>credit balance</b> will be recovered at the time of renewal.",
  "WIZARD": {
    "START_BUTTON": "Start",
    "COMPLETE_BUTTON": "Complete",
    "NEXT_BUTTON": "Next",
    "CLOSE_BUTTON": "Done!",
    "MANDATORY_FIELD_1": "The fields marked with",
    "MANDATORY_FIELD_2": "are mandatory",
    "SPLASH_STEP_TITLE": "Welcome to SMX studio!",
    "SPLASH_STEP_SUBTITLE": "Welcome to SMX studio!",
    "SPLASH_STEP_SUBTITLE_FIRST_ACCESS": "Follow these few steps to complete the configuration and start using the suite.",
    "SPLASH_STEP_SUBTITLE_PRIVACY_CONTRACT_MODIFIED": "We have updated the privacy policy or the contract terms. Accept the new conditions to continue using SMX studio.",
    "SUBSCRIPTION_STEP_TITLE": "Assign Subscription",
    "SUBSCRIPTION_STEP_SUBTITLE": "Specify whether the subscription you purchased is a new subscription or a renewal of a previous subscription.",
    "SUBSCRIPTION_STEP_NEW": "New Subscription",
    "SUBSCRIPTION_STEP_RENEWAL": "Renewal of an Existing Subscription",
    "SUBSCRIPTION_STEP_RENEWAL_SELECT_TITLE": "Select the subscription to renew",
    "SUBSCRIPTION_STEP_DEMO": "Renew from Demo",
    "SUBSCRIPTION_RENEWABLE_OPTION_TEXT": "Activation: {{startDate}} - Expiration: {{expirationDate}}",
    "PRIVACY_STEP_TITLE": "Privacy Policy",
    "PRIVACY_STEP_SUBTITLE": "Before proceeding, you must read and accept the privacy policy.",
    "PRIVACY_STEP_WARNING": "NOTE: If you are a minor, please have this window reviewed by a parent for their information.",
    "PRIVACY_STEP_INFO": "<p><b>Why do we request this information?</b></p><p>Your personal data (name and email) is necessary for:</p><ul><li>Creating and managing your personal account</li><li>Sending you communications related to the service</li><li>Providing you with technical assistance when needed</li></ul>",
    "PRIVACY_STEP_ACCEPT_LABEL": "I accept the <a href=\"{{privacyUrl}}\" target=\"_blank\" rel=\"noopener noreferrer\">privacy policy</a>",
    "PRIVACY_STEP_CHECKBOX_INFO": "I have read and accept the privacy policy.",
    "PRIVACY_STEP_DOWNLOAD_BUTTON": "View privacy policy",
    "PRIVACY_STEP_DOWNLOAD_INFO": "It's necessary  E' necessario visualizzare la privacy per continuare.",
    "CONTRACT_STEP_TITLE": "Terms of the contract",
    "CONTRACT_STEP_SUBTITLE": "Please read carefully and accept the terms and conditions of the service.",
    "CONTRACT_STEP_ACCEPT_LABEL": "I accept the terms of the <a href=\"{{contractUrl}}\" target=\"_blank\">service</a>",
    "CONTRACT_STEP_CHECKBOX_INFO": "I have read and accept the terms and conditions of the service.",
    "CONTRACT_STEP_DOWNLOAD_BUTTON": "View contract",
    "CONTRACT_STEP_DOWNLOAD_INFO": "You must view the agreement to continue.",
    "CONTRACT_STEP_DOWNLOAD_VERSION": "V{{version}}",
    "COMPLETE_STEP_TITLE": "Applying New Configurations",
    "COMPLETE_STEP_SUBTITLE_PRIVACY": "Recording acceptance of the privacy policy. Please wait...",
    "COMPLETE_STEP_SUBTITLE_CONTRACT": "Recording acceptance of the contract terms. Please wait...",
    "COMPLETE_STEP_SUBTITLE_SUBSCRIPTION": "Updating your subscription. Please wait...",
    "COMPLETE_STEP_SUBTITLE_COMPLETED": "Configuration completed!"
  },
  "GOOGLE_INVALID_GRANT_ERROR": "It seems there is an issue with Google authentication. To resolve it, please consult the <a href=\"https://www.anastasis.it/aiuto/faq/smx-studio\">FAQ</a>.",
  "LOADING_IN_PROGRESS": "Loading in progress...",
  "HELP_RESOURCES": "Help and resources",
  "EXPORT_TITLE": "SMX studio - Exports",
  "EXPORT_DESC": "After submitting the request, elaboration could take  some time.\nYou'll be notified by email as soon as the file is ready for download.",
  "EXPORT_PENDING": "You sent a request in date %date% at %time%.\nNo other requests will be accepted until the current one is completed.",
  "EXPORT_DONE": "Exports completed",
  "EXPORT_NONE": "No export available",
  "EXPORT_DATE": "Export date",
  "EXPORT_UNAVAILABLE": "This file is not available",
  "EXPORT_DOWNLOAD": "Download",
  "EXPORT_PENDING_BTN": "Export pending...",
  "EXPORT_REQUEST_BTN": "Request export",
  "PDFSPLIT_CREATING": "Creating the files...",
  "PDFSPLIT_WORKING": "Elaboration in progress...",
  "HEAVY_PDF": "These files have not been loaded because they are too big.<br/>Load them one at a time to receive detailed instructions.",
  "SPLITPDF": {
    "TITLE": "Warning: Very large file",
    "PAGES": "pages",
    "DESCRIPTION": "The PDF you are uploading is large. Uploading may take some time, and even if successful, it might be difficult to work with in SMX Studio.",
    "SHRINK_OPTION": "Reduce PDF size",
    "SHRINK_SUB": "Stops the upload and opens a new tab with Google, pre-set to search for compression tools, so you can choose your preferred service.",
    "SPLIT_OPTION": "Split the PDF into smaller files",
    "SPLIT_SUB": "Stops the upload and opens a new tab with Google, pre-set to search for splitting tools, so you can choose your preferred service.",
    "SPLIT_RECOMMENDED": "Recommended for optimal performance",
    "CONTINUE_OPTION": "Continue anyway and upload the large PDF.",
    "CONTINUE_SUB": "You might experience long waiting times to open it.",
    "COMPRESS_OPTION": "Cancel upload and reduce PDF size",
    "COMPRESS_SUB": "using online compression tools.",
    "CANCEL": "Cancel",
    "CONFIRM": "Confirm",
    "SHRINK_URL": "https://www.google.com/search?q=pdf+file+compress",
    "SPLIT_URL": "https://www.google.com/search?q=pdf+file+split"    
  },
  "DOC_SHARE_WARNING": "Warning: The document has not yet been created.Make a few changes to it first; once you've done that, you'll be able to share it without any issues."

}